export const NAN = 'nan';
export const NA = 'N/A';

export const SIZE = {
   EXTRA_LARGE: 'xl',
   LARGE: 'lg',
   MEDIUM: 'md',
   SMALL: 'sm',
   EXTRA_SMALL: 'xs',
};

export const NOTIFICATION_STATUS = {
   SUCCESS: 'success',
   WARNING: 'warning',
   ERROR: 'error',
   INFO: 'info',
};
export const TOAST_NOTIFICATION_STATUS = {
   POSITIVE: 'positive',
   NEUTRAL: 'neutral',
   WARNING: 'warning',
};

export const CATEGORY = {
   STRUCTURAL: 'STRUCTURAL',
   TACTICAL: 'TACTICAL',
};

export const CHART_NAME = {
   CHART_STRUCTURAL: CATEGORY.STRUCTURAL,
   CHART_TACTICAL: CATEGORY.TACTICAL,
   CHART_NUMBER_OF_O_AND_D_CHANGED_FARE: 'Number of O&Ds Changed Fare',
   CHART_AVERAGE_FARE_CHANGE: 'AVERAGE FARE CHANGE',
   CHART_COMPETITIVE_CHANGE_FARE: 'CHART COMPETITIVE CHANGE FARE',
};

export const DASHBOARD_TOP_TABS_VALUE = {
   RECOMMENDATION: 'recommendation',
   COMPETITION: 'competition',
};

export const COMPETITION_STATUS_TABS = {
   COMPETITOR_CHANGES_FARES: 'Fares',
};

export const CRITERIA_MARKET_KEY = 'market';

export const PERCENTAGE_ABSOLUTE_TABS_VALUE = {
   PERCENTAGE: 'percentage',
   ABSOLUTE: 'absolute',
   RELATIVE: 'relative',
};

export const DEFAULT_DASHBOARD_HISTORY_DAYS = 30;
export const DASHBOARD_HISTORY_DAYS_CONFIG_KEY =
   'FO_DASHBOARD_APPROVAL_DISPLAY_HISTORY';

export const IS_FARE_CHANGES_SUMMARY_FROM_ATHENA_KEY =
   'IS_FARE_CHANGES_SUMMARY_FROM_ATHENA';

export const URL_SAVE_CRITERIA_CONTEXT_ID = 'fo-dashboard';
export const URL_CORE_PRICING_SAVE_CRITERIA_CONTEXT_ID = 'core-pricing-fares';
export const URL_CORE_PRICING_DISTRIBUTION_SCREEN_SAVE_CRITERIA_CONTEXT_ID =
   'core-pricing-distribution';
export const URL_CORE_PRICING_FOOTNOTES_SCREEN_SAVE_CRITERIA_CONTEXT_ID =
   'core-pricing-footnotes';
export const URL_CORE_PRICING_RULES_SCREEN_SAVE_CRITERIA_CONTEXT_ID =
   'core-pricing-rules';
export const COMMA = ',';

export const FO_HOST_CARRIER_KEY = 'FO_HOST_CARRIER';

export const FO_BENCHMARK_COMPONENTS = [
   'BASE FARE',
   'YQ',
   'YR',
   '6H',
   '6I',
   '6J',
   '6K',
   'FUEL SURCHARGE',
   'OTHER',
   'VARIABLE',
   'CAT12 SURCHARGE',
];

export const CRITERIA_HEADER_DETAILS = [
   {
      KEY: 'org',
      VALUE: 'Origin',
   },
   {
      KEY: 'des',
      VALUE: 'Destination',
   },
   {
      KEY: 'mkt',
      VALUE: 'Market',
   },
   {
      KEY: 'mkt1',
      VALUE: 'Market',
   },
   {
      KEY: 'cxr',
      VALUE: 'Carrier Code',
   },
   {
      KEY: 'fbc',
      VALUE: 'Fare Class Code',
   },
   {
      KEY: 'tar',
      VALUE: 'Tariff Number',
   },
   {
      KEY: 'con',
      VALUE: 'Construction Method',
   },
   {
      KEY: 'vcc',
      VALUE: 'Vendor Change Code',
   },
   {
      KEY: 'gfs dt',
      VALUE: 'GFS Date',
   },
   {
      KEY: 'gfs',
      VALUE: 'GFS Filing Code',
   },
   {
      KEY: 'dow',
      VALUE: 'Day of the Week',
   },
   {
      KEY: 'min st',
      VALUE: 'Minimum Stay',
   },
   {
      KEY: 'rule tvl dt',
      VALUE: 'Rule Travel Dates',
   },
   {
      KEY: 'appl dt',
      VALUE: 'Applicable Dates',
   },
   {
      KEY: 'ft tvl dt',
      VALUE: 'Footnote Travel Dates',
   },
   {
      KEY: 'ft seas dt',
      VALUE: 'Footnote Season Dates',
   },
   {
      KEY: 'ft bo dt',
      VALUE: 'Footnote Blackout Dates',
   },
   {
      KEY: 'ft',
      VALUE: 'Footnote Code',
   },
   {
      KEY: 'rtg',
      VALUE: 'Routing',
   },
   {
      KEY: 'owrt',
      VALUE: 'OW/RT Indicator',
   },
   {
      KEY: 'cur',
      VALUE: 'Currency Code',
   },
   {
      KEY: 'amt',
      VALUE: 'Fare Amount',
   },
   {
      KEY: 'ow amt',
      VALUE: 'One Way Amount',
   },
   {
      KEY: 'rt amt',
      VALUE: 'Round Trip Amount',
   },
   {
      KEY: 'sur',
      VALUE: 'Surcharge',
   },
   {
      KEY: 'yq',
      VALUE: 'YQ',
   },
   {
      KEY: 'yr',
      VALUE: 'YR',
   },
   {
      KEY: 'tax',
      VALUE: 'Tax',
   },
   {
      KEY: 'ttl',
      VALUE: 'Total Fare',
   },
   {
      KEY: 'cab',
      VALUE: 'Cabin Code',
   },
   {
      KEY: 'rbd',
      VALUE: 'RBD',
   },
   {
      KEY: 'fst res',
      VALUE: 'First Reservation Date',
   },
   {
      KEY: 'lst res',
      VALUE: 'Last Reservation Date',
   },
   {
      KEY: 'fst tkt',
      VALUE: 'First Ticketing Date',
   },
   {
      KEY: 'lst tkt',
      VALUE: 'Last Ticketing Date',
   },
   {
      KEY: 'tvl st',
      VALUE: 'Travel Start Date',
   },
   {
      KEY: 'tvl end',
      VALUE: 'Travel End Date',
   },
   {
      KEY: 'brd',
      VALUE: 'Brand',
   },
   {
      KEY: 'brd det',
      VALUE: 'Brand Details',
   },
   {
      KEY: 'eff dt',
      VALUE: 'Effective Date',
   },
   {
      KEY: 'disc dt',
      VALUE: 'Discontinue Date',
   },
   {
      KEY: 'rec dt',
      VALUE: 'Received Date',
   },
   {
      KEY: 'tvl cmplt',
      VALUE: 'Travel Complete Date',
   },
   {
      KEY: 'tvl dt',
      VALUE: 'Travel Date',
   },
   {
      KEY: 'oc',
      VALUE: 'Origin Country Code',
   },
   {
      KEY: 'dc',
      VALUE: 'Destination Country Code',
   },
   {
      KEY: 'rule',
      VALUE: 'Rule Number',
   },
   {
      KEY: 'dow',
      VALUE: 'Day of the Week',
   },
   {
      KEY: 'seas dt',
      VALUE: 'Season Dates',
   },
   {
      KEY: 'ap',
      VALUE: 'Advanced Purchase',
   },
   {
      KEY: 'min st',
      VALUE: 'Minimum Stay',
   },
   {
      KEY: 'max st',
      VALUE: 'Maximum Stay',
   },
   {
      KEY: 'bo dt',
      VALUE: 'Blackout Dates',
   },
   {
      KEY: 'ftc',
      VALUE: 'Fare Type Code',
   },
   {
      KEY: 'dow tc',
      VALUE: 'Day Of Week Type Code',
   },
   {
      KEY: 'seas tc',
      VALUE: 'Season Type Code',
   },
   {
      KEY: 'ptc',
      VALUE: 'Passenger Type Code',
   },
   {
      KEY: 's. ptc',
      VALUE: 'Segment Passenger Type Code',
   },
   {
      KEY: 'tkt dsg',
      VALUE: 'Ticket Designators',
   },
   {
      KEY: 'status',
      VALUE: 'Fare Status',
   },
   {
      KEY: 'src',
      VALUE: 'Source',
   },
   {
      KEY: 'tier',
      VALUE: 'Market Tier',
   },
   {
      KEY: 'mkt grp',
      VALUE: 'Market Group',
   },
   {
      KEY: 'mkt typ',
      VALUE: 'Market Type',
   },
   {
      KEY: 'mkt ast',
      VALUE: 'Market Analyst',
   },
   {
      KEY: 'mkt cat',
      VALUE: 'Market Category',
   },
   {
      KEY: 'uac',
      VALUE: 'User Action Code',
   },
   {
      KEY: 'dg',
      VALUE: 'Distribution Group',
   },
   {
      KEY: 'created',
      VALUE: 'Created',
   },
   {
      KEY: 'last update',
      VALUE: 'Last Update Date',
   },
   {
      KEY: 'dist dt',
      VALUE: 'Distributed Date',
   },
   {
      KEY: 'description',
      VALUE: 'Description',
   },
   {
      KEY: 'cr user',
      VALUE: 'User',
   },
   {
      KEY: 'fare',
      VALUE: 'Total Fare',
   },
   {
      KEY: 'ftnt',
      VALUE: 'ftnt',
   },
   {
      KEY: 'rule',
      VALUE: 'Rule',
   },
   {
      KEY: 'addon',
      VALUE: 'addon',
   },
   {
      KEY: 'int dist dt',
      VALUE: 'Int Distribution Time Stamp',
   },
   {
      KEY: 'int dist time',
      VALUE: 'Int Distribution Time Stamp',
   },
   {
      KEY: 'ex ind',
      VALUE: 'Exclusive Access Indicator',
   },
   {
      KEY: 'rel ind',
      VALUE: 'Release Indicator',
   },
   {
      KEY: 'ign err',
      VALUE: 'Ignore Errors Indicator',
   },
   {
      KEY: 'lfc',
      VALUE: 'Low Fare Check Indicator',
   },
   {
      KEY: 'tax ind',
      VALUE: 'Tax Indicator',
   },
   {
      KEY: 'justification',
      VALUE: 'Justification',
   },
   {
      KEY: 'email',
      VALUE: 'Email',
   },
   {
      KEY: 'status',
      VALUE: 'Status',
   },
   {
      KEY: 'd/i',
      VALUE: 'Is Domestic Or International',
   },
   {
      KEY: 'timestamp',
      VALUE: 'Time Stamp',
   },
   {
      KEY: 'user',
      VALUE: 'User',
   },
   {
      KEY: 'action',
      VALUE: 'Action',
   },
   {
      KEY: 'notes',
      VALUE: 'Notes',
   },
   {
      KEY: 'createdAt',
      VALUE: 'createdAt',
   },
   {
      KEY: 'lastUpdatedAt',
      VALUE: 'lastUpdatedAt',
   },
   {
      KEY: 'timeStampAt',
      VALUE: 'timeStampAt',
   },
   {
      KEY: 'cat#',
      VALUE: 'Category Number',
   },
   {
      KEY: 'cat nm',
      VALUE: 'Category Name',
   },
   {
      KEY: 'sequence',
      VALUE: 'Sequence Number',
   },
   {
      KEY: 'loc1 type',
      VALUE: 'Location 1 Type',
   },
   {
      KEY: 'loc1',
      VALUE: 'Location 1',
   },
   {
      KEY: 'loc2 type',
      VALUE: 'Location 2 Type',
   },
   {
      KEY: 'loc2',
      VALUE: 'Location 2',
   },
   {
      KEY: 'notappl',
      VALUE: 'Application Indicator',
   },
   {
      KEY: 'jt cxr tbl',
      VALUE: 'Joint Carrier 997 ID',
   },
   {
      KEY: 'segs',
      VALUE: 'Segment Count',
   },
   {
      KEY: 'fares',
      VALUE: 'Fare Count',
   },
   {
      KEY: 'act',
      VALUE: 'Action Code',
   },
   {
      KEY: 'batch code',
      VALUE: 'Batch Code',
   },
   {
      KEY: 'batch num',
      VALUE: 'Batch Number',
   },
   {
      KEY: 'ft type',
      VALUE: 'Footnote Type',
   },
   {
      KEY: 's',
      VALUE: 'Footnote State Code',
   },
   {
      KEY: 'dist grp',
      VALUE: 'Distribution Group',
   },
   {
      KEY: 'chg',
      VALUE: 'Change Date',
   },
   {
      KEY: 'seg',
      VALUE: 'Segment Number',
   },
   {
      KEY: 'rec3id',
      VALUE: 'Rec3 Table ID',
   },
   {
      KEY: 'io',
      VALUE: 'Inbound/Outbound Indicator',
   },
   {
      KEY: 'dir',
      VALUE: 'Directional Indicator',
   },
   {
      KEY: 'rel',
      VALUE: 'Relational Indicator',
   },
   {
      KEY: 'tvl st',
      VALUE: 'Travel Start Date',
   },
   {
      KEY: 'tvl cmplt',
      VALUE: 'Travel Complete Date',
   },
   {
      KEY: 'ri',
      VALUE: 'Return Ind',
   },
   {
      KEY: 'uvd',
      VALUE: 'Unavailable Tag',
   },
   {
      KEY: 'tvleff 994',
      VALUE: 'Override Travel Eff Date',
   },
   {
      KEY: 'reseff 994',
      VALUE: 'Override Reser Eff Date',
   },
   {
      KEY: 'geo 995',
      VALUE: 'Geographic 995 Id',
   },
   {
      KEY: 'loc1 995',
      VALUE: 'Geo Loc1 Code',
   },
   {
      KEY: 'tsi 995',
      VALUE: 'Geo 995 TSI Ind',
   },
   {
      KEY: 'text',
      VALUE: 'Text 996',
   },
   {
      KEY: 'tvl end',
      VALUE: 'Travel End Date',
   },
   {
      KEY: 'ret tm',
      VALUE: 'Return Time Of Day',
   },
   {
      KEY: 'ovrd 994',
      VALUE: 'Override 994 Id',
   },
   {
      KEY: 'tvldis 994',
      VALUE: 'Override Travel Disc Date',
   },
   {
      KEY: 'resdisc 994',
      VALUE: 'Override Reser Disc Date',
   },
   {
      KEY: 'loctyp 995',
      VALUE: 'Geo Location Type',
   },
   {
      KEY: 'loctyp',
      VALUE: 'Location Type',
   },
   {
      KEY: 'loc2 995',
      VALUE: 'Geo Loc2 Code',
   },
   {
      KEY: 'text 996',
      VALUE: 'Text 996 Id',
   },
   {
      KEY: 'ovr ind',
      VALUE: 'Override Ind',
   },
   {
      KEY: 'sea typ',
      VALUE: 'Season Type code',
   },
   {
      KEY: 'sea st',
      VALUE: 'Season Start Date',
   },
   {
      KEY: 'sea end',
      VALUE: 'Season End Date',
   },
   { KEY: 'app ind', VALUE: 'Application Ind' },
   { KEY: 'int con wv', VALUE: 'International Conn Waiver' },
   { KEY: 'blackout st', VALUE: 'Blackout Start Date' },
   { KEY: 'blackout end', VALUE: 'Blackout End Date' },
   { KEY: 'resdisc 994', VALUE: 'Override Reser Disc Date' },
   { KEY: 'and geo 995', VALUE: 'AND Geographic 995 Id' },
   { KEY: 'and loctyp 995', VALUE: 'AND Geo Location Type' },
   { KEY: 'and loc1 995', VALUE: 'AND Geo Loc1 Code' },
   { KEY: 'and loc2 995', VALUE: 'AND Geo Loc2 Code' },
   { KEY: 'and tsi 995', VALUE: 'AND Geo TSI Ind' },
   { KEY: 'bet geo 995', VALUE: 'Between Geographic 995 Id' },
   { KEY: 'bet loctyp 995', VALUE: 'Between Geo Location Type' },
   { KEY: 'bet loc1 995', VALUE: 'Between Geo Loc1 Code' },
   { KEY: 'bet loc2 995', VALUE: 'Between Geo Loc2 Code' },
   { KEY: 'bet tsi 995', VALUE: 'Between Geo TSI Ind' },
   { KEY: 'chg user', VALUE: 'Change User' },
   { KEY: 'chg dt', VALUE: 'Change Date' },
   { KEY: 'gen rule app', VALUE: 'gen rule app' },
   { KEY: 'gen rule #', VALUE: 'gen rule #' },
   { KEY: 'gen rule tar', VALUE: 'gen rule tar' },
   { KEY: 'jnt cxr tbl', VALUE: 'jnt cxr tbl' },
   { KEY: 'dow typ', VALUE: 'dow typ' },
   { KEY: 'seas typ', VALUE: 'seas typ' },
   { KEY: 'fare typ', VALUE: 'fare typ' },
   { KEY: 'fare appl', VALUE: 'fare appl' },
   { KEY: 'loc2 zn', VALUE: 'loc2 zn' },
   { KEY: 'loc1 zn', VALUE: 'loc1 zn' },
   { KEY: 'tvl from', VALUE: 'tvl from' },
   { KEY: 'tvl to', VALUE: 'tvl to' },
   { KEY: 'ovrd', VALUE: 'ovrd' },
   { KEY: 'max age', VALUE: 'Maximum Age' },
   { KEY: 's. max age', VALUE: 'Segment Maximum age' },
   { KEY: 'min age', VALUE: 'Minimum Age' },
   { KEY: 's. min age', VALUE: 'Segment Minimum Age' },
   { KEY: 'psc', VALUE: 'Passenger Status Code' },
   { KEY: 'ac', VALUE: 'Account Code' },
   { KEY: 'app ind', VALUE: 'Application Indicator' },
   { KEY: 'first occ', VALUE: 'First Occurrence' },
   { KEY: 'last occ', VALUE: 'Last Occurrence' },
   { KEY: 'id req ind', VALUE: 'Id Required Indicator' },
   { KEY: 'loc code', VALUE: 'Location Code' },
   { KEY: 'loc type', VALUE: 'Location Type' },
   { KEY: 'start tod', VALUE: 'Start Time of day' },
   { KEY: 'stop tod', VALUE: 'Stop Time of day' },
   { KEY: 'tod ind', VALUE: 'Time Application Code' },
   { KEY: 'ret occur', VALUE: 'Return Day Occurrence' },
   { KEY: 'ret ind', VALUE: 'Return ind' },
   { KEY: 'neg ind', VALUE: 'Negate Ind' },
   { KEY: 'min stay p', VALUE: 'Minimum Stay Period' },
   { KEY: 'min stay u', VALUE: 'Minimum Stay Unit' },
   { KEY: 'dow ind', VALUE: 'Day Of Week Indicator' },
   { KEY: 'tod', VALUE: 'Time Of day' },
   { KEY: 'wav code', VALUE: 'Waiver Code' },
   { KEY: 'e/l code', VALUE: 'Earlier Later code' },
   { KEY: 'min stay d', VALUE: 'Minimum Stay Date' },
   { KEY: 'max stay d', VALUE: 'Maximum Stay Date' },
   { KEY: 'wav date', VALUE: 'Waiver Date' },
   { KEY: 'wav e/l', VALUE: 'Waiver Earlier Later Code' },
   { KEY: 'wav p', VALUE: 'Waiver Period' },
   { KEY: 'wav u', VALUE: 'Waiver Unit' },
   { KEY: 'app code', VALUE: 'Application Code' },
   { KEY: 'g mil', VALUE: 'Greater Mileage' },
   { KEY: 'l mil', VALUE: 'Lesser Mileage' },
   { KEY: 'from geo 995', VALUE: 'From Geographic 995 Id' },
   { KEY: 'from loctyp 995', VALUE: 'From Geo Location Type' },
   { KEY: 'from loc1 995', VALUE: 'From Geo Loc1 Code' },
   { KEY: 'from loc2 995', VALUE: 'From Geo Loc2 Code' },
   { KEY: 'from tsi 995', VALUE: 'From Geo TSI Ind' },
   { KEY: 'to geo 995', VALUE: 'To Geographic 995 Id' },
   { KEY: 'to loctyp 995', VALUE: 'To Geo Location Type' },
   { KEY: 'to loc1 995', VALUE: 'To Geo Loc1 Code' },
   { KEY: 'to loc2 995', VALUE: 'To Geo Loc2 Code' },
   { KEY: 'to tsi 995', VALUE: 'To Geo TSI Ind' },
   { KEY: 'maxstayp', VALUE: 'Maximum Stay Period' },
   { KEY: 'maxstayu', VALUE: 'Maximum Stay Unit' },
   { KEY: 'ret code', VALUE: 'Return Travel Code' },
   { KEY: 'tkt ind', VALUE: 'Ticketing Ind' },
   { KEY: 'first tod', VALUE: 'First Time Of Day' },
   { KEY: 'first p', VALUE: 'First Period' },
   { KEY: 'first u', VALUE: 'First Unit' },
   { KEY: 'last tod', VALUE: 'Last Time Of Day' },
   { KEY: 'last p', VALUE: 'Last Period' },
   { KEY: 'last u', VALUE: 'Last Unit' },
   { KEY: 'oth res ind', VALUE: 'Other Reservation Ind' },
   { KEY: 'imm tkt ind', VALUE: 'Immediate Tkt Ind' },
   { KEY: 'not perm ind', VALUE: 'Not Permitted Ind' },
   { KEY: 'wait code', VALUE: 'Waitlist Code' },
   { KEY: 'seg code', VALUE: 'Segment Confirm Code' },
   { KEY: 'each seg ind', VALUE: 'Each Segment Ind' },
   { KEY: 'tkt tod', VALUE: 'Ticketing time of day' },
   { KEY: 'tkt p', VALUE: 'Ticket Period' },
   { KEY: 'tkt u', VALUE: 'Ticket Unit' },
   { KEY: 'depart op code', VALUE: 'Depart Option code' },
   { KEY: 'time depart', VALUE: 'Time before Depart' },
   { KEY: 'depart u', VALUE: 'Depart Unit' },
   { KEY: 'tsi', VALUE: 'Travel Segment Indicator' },
   { KEY: 'both code', VALUE: 'Both Code' },
   { KEY: 'exc time', VALUE: 'Exc Time' },
   { KEY: 'exc unit', VALUE: 'EXC Unit' },
   { KEY: 'res date', VALUE: 'Reservation Date' },
   { KEY: 'tkt date', VALUE: 'Ticket Date' },
   { KEY: 'start p', VALUE: 'Start Period' },
   { KEY: 'stop p', VALUE: 'Stop Period' },
   { KEY: 'first tod', VALUE: 'First time of day' },
   { KEY: 'tod app ind', VALUE: 'Time Of Day App Ind' },
   { KEY: 'sur type', VALUE: 'Surcharge Type' },
   { KEY: 'eqp code', VALUE: 'Equipment Code' },
   { KEY: 'tvl por ind', VALUE: 'Travel Portion Ind' },
   { KEY: 'sec por ind', VALUE: 'Sector Portion Ind' },
   { KEY: 'sur 1 amt', VALUE: 'Surcharge 1 Amount' },
   { KEY: 'curr 1 code', VALUE: 'Currency 1 Code' },
   { KEY: 'sur 2 amt', VALUE: 'Surcharge 2 Amount' },
   { KEY: 'curr 2 code', VALUE: 'Currency 2 Code' },
   { KEY: 'percent', VALUE: 'percent' },
   { KEY: 'per app code', VALUE: 'Percent Application Code' },
   { KEY: 'flight 986 id', VALUE: 'Carrier Flight 986 Id' },
   { KEY: 'flt no 1', VALUE: 'Flight Number 1' },
   { KEY: 'flt no 2', VALUE: 'Flight Number 2' },
   { KEY: 'mkt cxr', VALUE: 'Marketing Carrier' },
   { KEY: 'op cxr', VALUE: 'Operating Carrier' },
   { KEY: 'flight 986', VALUE: 'Carrier Flight 986' },
   { KEY: 'vol ind', VALUE: 'Voluntary Changes' },
   { KEY: 'invol ind', VALUE: 'Involuntary Changes' },
   { KEY: 'can ref', VALUE: 'Cancellation and Refunds' },
   { KEY: 'tkt ref', VALUE: 'Ticket Refund Ind' },
   { KEY: 'can ind', VALUE: 'Cancellation Ind' },
   { KEY: 'fail ind', VALUE: 'Failure Ind' },
   { KEY: 'reissue ind', VALUE: 'Reissue Ind' },
   { KEY: 'replace ind', VALUE: 'Replace Ind' },
   { KEY: 'change ind', VALUE: 'Change Ind' },
   { KEY: 'pta ind', VALUE: 'PTA Ind' },
   { KEY: 'refund ind', VALUE: 'Refund Ind' },
   { KEY: 'por code', VALUE: 'Portion code' },
   { KEY: 'penalty 1 amt', VALUE: 'Penalty 1 Amount' },
   { KEY: 'penalty 2 amt', VALUE: 'Penalty 2 Amount' },
   { KEY: 'h/l ind', VALUE: 'High Low Ind' },
   { KEY: 'dea wav ind', VALUE: 'Death Waiver Ind' },
   { KEY: 'ill wav ind', VALUE: 'Illness Waiver Ind' },
   { KEY: 'f dea wav ind', VALUE: 'Family Death Waiver' },
   { KEY: 'f ill wav ind', VALUE: 'Family Illness Waiver' },
   { KEY: 'sch c ind', VALUE: 'Schedule Change Ind' },
   { KEY: 'tkt ug ind', VALUE: 'Ticket Upgrade Ind' },
   { KEY: 'min num', VALUE: 'Minimum number' },
   { KEY: 'max num', VALUE: 'Maximum number' },
   { KEY: 'out num', VALUE: 'Outbound number' },
   { KEY: 'in num', VALUE: 'Inbound Number' },
   { KEY: 'not both ind', VALUE: 'Not Both Ind' },
   { KEY: 'open jaw', VALUE: 'Open Jaw Ind' },
   { KEY: 'circle trip', VALUE: 'Circle Trip Ind' },
   { KEY: 'circle t pl', VALUE: 'Circle Trip Plus Ind' },
   { KEY: 'gate perm', VALUE: 'Gateway Permitted Code' },
   { KEY: 'min time p', VALUE: 'Min Time Period' },
   { KEY: 'min time u', VALUE: 'Min Time Unit' },
   { KEY: 'max time p', VALUE: 'Max Time Period' },
   { KEY: 'max time u', VALUE: 'Max Time Unit' },
   { KEY: 'same stop', VALUE: 'Same Points Stopovers' },
   { KEY: 'same transits', VALUE: 'Same Points Transits' },
   { KEY: 'same connect', VALUE: 'Same Points Conn' },
   { KEY: 'app 1 ind', VALUE: 'Application 1 Ind' },
   { KEY: 'first amt num', VALUE: 'First Amount Stop Num' },
   { KEY: 'first amt', VALUE: 'First Amount' },
   { KEY: 'add amt 1 num', VALUE: 'Additional Amount 1 Stop Num' },
   { KEY: 'add amt 1', VALUE: 'Additional Amount 1' },
   { KEY: 'curr 1', VALUE: 'Currency 1 Code' },
   { KEY: 'dec 1 no', VALUE: 'Decimal 1' },
   { KEY: 'first amt 2', VALUE: 'First Amount 2' },
   { KEY: 'add amt 2', VALUE: 'Additional Amount 2' },
   { KEY: 'curr 2', VALUE: 'Currency 2 Code' },
   { KEY: 'dec 2 no', VALUE: 'Decimal 2' },
   { KEY: 'seg num', VALUE: 'Number of Segments' },
   { KEY: 'same cxr code', VALUE: 'Same Carrier code' },
   { KEY: 'stop num', VALUE: 'Number of Stopovers' },
   { KEY: 'in cxr', VALUE: 'Inbound Carriers' },
   { KEY: 'app code', VALUE: 'Application Code' },
   { KEY: 'loc type', VALUE: 'Location Type' },
   { KEY: 'loc 1 code', VALUE: 'Location 1 code' },
   { KEY: 'loc 2 code', VALUE: 'Location 2 code' },
   { KEY: 'out cxr', VALUE: 'Outbound carrier code' },
   { KEY: 'i/o', VALUE: 'I/O ind' },
   { KEY: 'charge code', VALUE: 'Charge code' },
   { KEY: 'point 993', VALUE: 'Same Points 993 ID' },
   { KEY: 'and tsi', VALUE: 'AND Geo TSI Ind' },
   { KEY: 'and loc2', VALUE: 'AND Geo Loc2 Code' },
   { KEY: 'and loc1', VALUE: 'AND Geo Loc1 Code' },
   { KEY: 'and loctyp', VALUE: 'AND Geo Location Type' },
   { KEY: 'bet tsi', VALUE: 'Between Geo TSI Ind' },
   { KEY: 'bet loc2', VALUE: 'Between Geo Loc2 Code' },
   { KEY: 'bet loc1', VALUE: 'Between Geo Loc1 Code' },
   { KEY: 'bet loctyp', VALUE: 'Between Geo Location Type' },
   { KEY: 'from tsi', VALUE: 'From Geo TSI Ind' },
   { KEY: 'from loc2', VALUE: 'From Geo Loc2 Code' },
   { KEY: 'from loc1', VALUE: 'From Geo Loc1 Code' },
   { KEY: 'from loctyp', VALUE: 'From Geo Location Type' },
   { KEY: 'tkt val ind', VALUE: 'Ticket Validity Ind' },
   { KEY: 'jrny code', VALUE: 'Journey Code' },
   { KEY: 'price unit', VALUE: 'Pricing Unit' },
   { KEY: 'fare co code', VALUE: 'Fare Component code' },
   { KEY: 'from code', VALUE: 'From Point Code' },
   { KEY: 'to code', VALUE: 'To Point code' },
   { KEY: 'pen 1 amt', VALUE: 'Penalty 1 Amount' },
   { KEY: 'pen percent', VALUE: 'Penalty Percent' },
   { KEY: 'pen 2 amt', VALUE: 'Penalty 2 Amount' },
   { KEY: 'h/l code', VALUE: 'High Low Code' },
   { KEY: 'min amt', VALUE: 'Minimum Amount' },
   { KEY: 'curr code', VALUE: 'Currency code' },
   { KEY: 'dec', VALUE: 'Decimal' },
   { KEY: 'assess code', VALUE: 'Assessment code' },
   { KEY: 'fee app code', VALUE: 'Fee Application code' },
   { KEY: 'tkt type', VALUE: 'Ticket Type code' },
   { KEY: 'dis type', VALUE: 'Discount Type Code' },
   { KEY: 'res type', VALUE: 'Residual Penalty Code' },
   { KEY: 'ref type', VALUE: 'Refund Type Code' },
   { KEY: 'endo type', VALUE: 'Endorsement Ind' },
   { KEY: 'reissue 988', VALUE: 'Reissue 988 Id' },
   { KEY: 'waiver 987', VALUE: 'Waiver 987 Id' },
   { KEY: 'tkt limit', VALUE: 'Ticket Time Limit' },
   { KEY: 'adv res', VALUE: 'Advance Reservation' },
   { KEY: 'full flown', VALUE: 'Fully Flown' },
   { KEY: 'org sch ref', VALUE: 'Originally Scheduled Refund' },
   { KEY: 'org sch p', VALUE: 'Originally Scheduled Period' },
   { KEY: 'org sch u', VALUE: 'Originally Scheduled Unit' },
   { KEY: 'cancel ind', VALUE: 'Cancellation Ind' },
   { KEY: 'fare point', VALUE: 'Fare Break Points' },
   { KEY: 're ind', VALUE: 'Re Price Ind' },
   { KEY: 'rtn', VALUE: 'Rule Tariff Number' },
   { KEY: 'pvt pub ind', VALUE: 'Private Public Ind' },
   { KEY: 'rule num', VALUE: 'Rule Number' },
   { KEY: 'field ind', VALUE: 'Field Ind' },
   { KEY: 'fcc', VALUE: 'Fare Class Code' },
   { KEY: 's. fcc', VALUE: 'Segment Fare Class Code' },
   { KEY: 'same code', VALUE: 'Same Code' },
   { KEY: 'fare code', VALUE: 'Special Fare Code' },
   { KEY: 'ow/rt', VALUE: 'OW/RT Ind' },
   { KEY: 'fare amt', VALUE: 'Fare Amount Code' },
   { KEY: 'book code', VALUE: 'Booking Code' },
   { KEY: 'base percent', VALUE: 'Base Fare Percent' },
   { KEY: 'h/l amt', VALUE: 'High Low Amount Code' },
   { KEY: 'curr 3', VALUE: 'Currency 3 Code' },
   { KEY: 'dec 3 no', VALUE: 'Decimal 3' },
   { KEY: 'pu/fc', VALUE: 'PU/FC Code' },
   { KEY: 'calc op', VALUE: 'Calculation Option' },
   { KEY: 'dis tag', VALUE: 'Discount Tag' },
   { KEY: 'refund', VALUE: 'Form Of Refund' },
   { KEY: 'non ref code', VALUE: 'Tax Non Refund Code' },
   { KEY: 'cust p', VALUE: 'Customer First Period' },
   { KEY: 'cust u', VALUE: 'Customer First Unit' },
   { KEY: 'res tkt code', VALUE: 'Reservation Ticketing Code' },
   { KEY: 'cxr 990', VALUE: 'Carrier 990 Id' },
   { KEY: 'fare type 974', VALUE: 'Fare Type Table 974 Id' },
   { KEY: 'wav 987', VALUE: 'Waiver 987 Id' },
   { KEY: 'ind tag', VALUE: 'Identification Tag' },
   { KEY: 'res code', VALUE: 'Resident Code' },
   { KEY: 'tvl ind', VALUE: 'Travel Ind' },
   { KEY: 'no of miles', VALUE: 'Number of Miles' },
   { KEY: 'tkt type ind', VALUE: 'Ticket Type Ind' },
   { KEY: 'locale geo', VALUE: 'Locale GEO 995 Id' },
   { KEY: 'locale loctyp', VALUE: 'Locale Geo Location Type' },
   { KEY: 'locale loc1', VALUE: 'Locale Geo Loc1 Code' },
   { KEY: 'locale loc2', VALUE: 'Locale Geo Loc2 Code' },
   { KEY: 'locale tsi', VALUE: 'LocaleGeo TSI Ind' },
   { KEY: 'non r geo', VALUE: 'Non Residence GEO 995 Id' },
   { KEY: 'non r loctyp', VALUE: 'Non Res Geo Location Type' },
   { KEY: 'non r loc1', VALUE: 'Non Res Geo Loc1 Code' },
   { KEY: 'non r loc2', VALUE: 'Non Res Geo Loc2 Code' },
   { KEY: 'non r tsi', VALUE: 'Non res Geo TSI Ind' },
   { KEY: 'loc type code', VALUE: 'Location Type Code' },
   { KEY: 'cxn stop', VALUE: 'Connection or Stopover' },
   { KEY: 'no hip', VALUE: 'No Higher Intermediate' },
   { KEY: 'all sec ind', VALUE: 'All Sectors Ind' },
   { KEY: 'out jrny ind', VALUE: 'Outbound Journey Ind' },
   { KEY: 'out sec ind', VALUE: 'Atleast One Sector Ind' },
   { KEY: 'same com ind', VALUE: 'Same Compartment Ind' },
   { KEY: 'same rul ind', VALUE: 'Same Rule Ind' },
   { KEY: 'acc pass ind', VALUE: 'Accompany Passenger Ind' },
   { KEY: 'one sec ind', VALUE: 'Atleast One Sector Ind' },
   { KEY: 'fare book', VALUE: 'Fare Booking Ind' },
   { KEY: 'dep req code', VALUE: 'Deposit Req Code' },
   { KEY: 'first min amt', VALUE: 'First Min Deposit Amt' },
   { KEY: 'first min curr', VALUE: 'First Min Deposit Curr' },
   { KEY: 'first min dec', VALUE: 'First Min Deposit Decimal' },
   { KEY: 'sec min amt', VALUE: 'Sec Min Deposit Amt' },
   { KEY: 'sec min curr', VALUE: 'Sec Min Deposit Curr' },
   { KEY: 'sec min dec', VALUE: 'Sec Min Deposit Decimal' },
   { KEY: 'fare per dep', VALUE: 'Fare Percent To Deposit' },
   { KEY: 'dep app code', VALUE: 'Deposit App Code' },
   { KEY: 'dep code', VALUE: 'Deposit Code' },
   { KEY: 'last date', VALUE: 'Last Date' },
   { KEY: 'seat dep ind', VALUE: 'Seat Deposit Ind' },
   { KEY: 'non ref ind', VALUE: 'Non Refundable Deposit Ind' },
   { KEY: 'first ref amt', VALUE: 'First Refund Amount' },
   { KEY: 'first ref curr', VALUE: 'First Refund Curr' },
   { KEY: 'first ref dec', VALUE: 'First Refund Decimal' },
   { KEY: 'sec ref amt', VALUE: 'Sec Refund Amount' },
   { KEY: 'sec ref curr', VALUE: 'Sec Refund Curr' },
   { KEY: 'sec ref dec', VALUE: 'Sec Refund Decimal' },
   { KEY: 'ref percent', VALUE: 'Refund Percent' },
   { KEY: 'ref app code', VALUE: 'Refund Application Code' },
   { KEY: 'ref days', VALUE: 'Refund Days' },
   { KEY: 'wav app code', VALUE: 'Waiver App Code' },
   { KEY: 'death code', VALUE: 'Death Code' },
   { KEY: 'ill code', VALUE: 'Illness Code' },
   { KEY: 'sch change', VALUE: 'Schedule Change' },
   { KEY: 'tkt ug', VALUE: 'Ticket Upgrade' },
   { KEY: 'denial docs', VALUE: 'Denial Of Docs' },
   { KEY: 'jury duty', VALUE: 'Jury Duty' },
   { KEY: 'mil order', VALUE: 'Military Orders' },
   { KEY: 'airfare inc', VALUE: 'Airfare Increase' },
   { KEY: 'full seats', VALUE: 'Full Paid Seats' },
   { KEY: 'dep geo 995', VALUE: 'Deposit Geo 995 Id' },
   { KEY: 'dep loctyp', VALUE: 'Dep Geo Location Type' },
   { KEY: 'dep loc1', VALUE: 'Dep Geo Loc1 Code' },
   { KEY: 'dep loc2', VALUE: 'Dep Geo Loc2 Code' },
   { KEY: 'dep tsi', VALUE: 'Dep Geo TSI Ind' },
   { KEY: 'ref geo 995', VALUE: 'Refund Geo 995 Id' },
   { KEY: 'ref loctyp', VALUE: 'Ref Geo Location Type' },
   { KEY: 'ref loc1', VALUE: 'Ref Geo Loc1 Code' },
   { KEY: 'ref loc2', VALUE: 'Ref Geo Loc2 Code' },
   { KEY: 'ref tsi', VALUE: 'Ref Geo TSI Ind' },
   { KEY: 'app title', VALUE: 'Application Title' },
   { KEY: 'first class', VALUE: 'First Class Ind' },
   { KEY: 'bus class', VALUE: 'Business Class Ind' },
   { KEY: 'eco class', VALUE: 'Economy Class Ind' },
   { KEY: 'coach class', VALUE: 'Coach Class Ind' },
   { KEY: 'off co class', VALUE: 'Off Peak Coach Ind' },
   { KEY: 'super ind', VALUE: 'Supersonic Ind' },
   { KEY: 'ow rule ind', VALUE: 'One Way Rule Ind' },
   { KEY: 'rt rule ind', VALUE: 'Round Trip Rule Ind' },
   { KEY: 'ow ind', VALUE: 'One Way Ind' },
   { KEY: 'rt ind', VALUE: 'Round Trip Ind' },
   { KEY: 'ct ind', VALUE: 'Circle Trip Ind' },
   { KEY: 'oj ind', VALUE: 'Open Jaw Ind' },
   { KEY: 'soj ind', VALUE: 'Single Open Jaw Ind' },
   { KEY: 'origin soj ind', VALUE: 'Origin SOJ Ind' },
   { KEY: 'ta soj ind', VALUE: 'Turn Around SOJ Ind' },
   { KEY: 'doj ind', VALUE: 'Double Open Jaw Ind' },
   { KEY: 'rtw ind', VALUE: 'Round the World Ind' },
   { KEY: 'jt ind', VALUE: 'Joint Transport Ind' },
   { KEY: 'inc tour', VALUE: 'Inclusive Tour Code' },
   { KEY: 'group code', VALUE: 'Group Code' },
   { KEY: 'pur code', VALUE: 'Purchase Code' },
   { KEY: 'inter points', VALUE: 'Intermediate Points Ind' },
   { KEY: 'd/i code', VALUE: 'Dom Int Code' },
   { KEY: 'seg no', VALUE: 'No. of Segments' },
   { KEY: 'locale code', VALUE: 'Geo Locale Code' },
   { KEY: 'add fare text id', VALUE: 'Additional Fare Text 996 Id' },
   { KEY: 'add fare text', VALUE: 'Additional Fare Text 996' },
   { KEY: 'capa text id', VALUE: 'Capacity Text 996 Id' },
   { KEY: 'capa text', VALUE: 'Capacity Text 996' },
   { KEY: 'no app id', VALUE: 'Not Application Text 996 ID' },
   { KEY: 'no app text', VALUE: 'Not Application Text 996' },
   { KEY: 'other text id', VALUE: 'Other Text 996 ID' },
   { KEY: 'other text', VALUE: 'Other Text 996' },
   { KEY: 'flight no 1', VALUE: 'Flight Number 1' },
   { KEY: 'cxr code 1', VALUE: 'Carrier Code 1' },
   { KEY: 'cxr 1 986 id', VALUE: 'Carrier Flight 1 986 Id' },
   { KEY: 'cxr 1 986', VALUE: 'Carrier Flight 1 986' },
   { KEY: 'rel ind 1', VALUE: 'Relational Ind 1' },
   { KEY: 'flight no 2', VALUE: 'Flight Number 2' },
   { KEY: 'cxr code 2', VALUE: 'Carrier Code 2' },
   { KEY: 'cxr 2 986 id', VALUE: 'Carrier Flight 2 986 Id' },
   { KEY: 'cxr 2 986', VALUE: 'Carrier Flight 2 986' },
   { KEY: 'rel ind 2', VALUE: 'Relational Ind 2' },
   { KEY: 'flight no 3', VALUE: 'Flight Number 3' },
   { KEY: 'cxr code 3', VALUE: 'Carrier Code 3' },
   { KEY: 'dir ind', VALUE: 'Directional Ind' },
   { KEY: 'loc val ind', VALUE: 'Location Validity Ind' },
   { KEY: 'loc code ind', VALUE: 'Location Code Ind' },
   { KEY: 'via ind', VALUE: 'Via Ind' },
   { KEY: 'hid ind', VALUE: 'Hidden Ind' },
   { KEY: 'non stop ind', VALUE: 'Non Stop Ind' },
   { KEY: 'direct ind', VALUE: 'Direct Ind' },
   { KEY: 'mul stop ind', VALUE: 'Multi Stop Ind' },
   { KEY: 'one stop ind', VALUE: 'One Stop Ind' },
   { KEY: 'online ind', VALUE: 'Online Connect Ind' },
   { KEY: 'inter ind', VALUE: 'Interline Connect Ind' },
   { KEY: 'same ind', VALUE: 'Same Flight Ind' },
   { KEY: 'eqp code ind', VALUE: 'Equipment Code Ind' },
   { KEY: 'via geo 995', VALUE: 'Via Geographic 995 Id' },
   { KEY: 'via loctyp', VALUE: 'Via Geo Location Type' },
   { KEY: 'via loc1', VALUE: 'Via Geo Loc1 Code' },
   { KEY: 'via loc2', VALUE: 'Via Geo Loc2 Code' },
   { KEY: 'via tsi', VALUE: 'Via Geo TSI Ind ' },
   { KEY: 'min', VALUE: 'Min number of transfer' },
   { KEY: 'max', VALUE: 'Max number of transfer' },
   { KEY: 'prm', VALUE: 'Primary transfer code' },
   { KEY: 'max prm', VALUE: 'Max primary transfers' },
   { KEY: 'sme', VALUE: 'Same carrier transfer code' },
   { KEY: 't sme', VALUE: 'Transfer Same Carrier' },
   { KEY: 'max sme', VALUE: 'Max same transfer' },
   { KEY: 'interline', VALUE: 'Interline transfer code' },
   { KEY: 't interline', VALUE: 'Transfer Interline' },
   { KEY: 'max inter', VALUE: 'Max interline transfer' },
   { KEY: 'oth cxr', VALUE: 'Other Carrier transfer code' },
   { KEY: 't oth cxr', VALUE: 'Transfer Other Carrier' },
   { KEY: 'max oth cxr', VALUE: 'Max other carrier transfer' },
   { KEY: 'out', VALUE: 'Outbound Transfers' },
   { KEY: 'in', VALUE: 'Inbound Transfers' },
   { KEY: 'or', VALUE: 'Outbound return permit' },
   { KEY: 'surf tag', VALUE: 'Surface Tag' },
   { KEY: 'surf 976 id', VALUE: 'Surface table 976 Id' },
   { KEY: 'emb tag', VALUE: 'Embedded Surface Tag' },
   { KEY: 'emb 976 id', VALUE: 'Embedded Table 976 Id' },
   { KEY: 'appl', VALUE: 'Transfer Charges Ind' },
   { KEY: 'charge 1 no', VALUE: 'Max Transfer Assess' },
   { KEY: 'charge 1 amt', VALUE: 'Charge 1' },
   { KEY: 'charge 2 no', VALUE: 'Max Transfer Charge' },
   { KEY: 'charge 2 amt', VALUE: 'Charge 2' },
   { KEY: 'dec no 1', VALUE: 'Decimal Place 1' },
   { KEY: 'charge 3 amt', VALUE: 'Charge 3' },
   { KEY: 'charge 4 amt', VALUE: 'Charge 4' },
   { KEY: 'dec no 2', VALUE: 'Decimal Place 2' },
   { KEY: 'no of segs', VALUE: 'No of Segments' },
   { KEY: 'tran appl', VALUE: 'Transfer Application' },
   { KEY: 'num', VALUE: 'Transfer Number' },
   { KEY: 'primary', VALUE: 'Transfer Primary' },
   { KEY: 'cnx or stop', VALUE: 'Connection or Stopover' },
   { KEY: 'cxr app code', VALUE: 'Carrier App Code' },
   { KEY: 'in cxr code', VALUE: 'In Carrier Code' },
   { KEY: 'in cxr 990 id', VALUE: 'In carrier 990 Id' },
   { KEY: 'out cxr code', VALUE: 'Out Carrier Code' },
   { KEY: 'out cxr 990 id', VALUE: 'Out carrier 990 Id' },
   { KEY: 'type code', VALUE: 'Type Code' },
   { KEY: 'loc 978 id', VALUE: 'Location Zone 978 Id' },
   { KEY: 'bet loc', VALUE: 'Between Location' },
   { KEY: 'gateway', VALUE: 'Gateway' },
   { KEY: 'restriction', VALUE: 'Restriction' },
   { KEY: 'por ind', VALUE: 'Portion Indicator' },
   { KEY: 'transfer', VALUE: 'Transfer Charge' },
   { KEY: 'no disc ind', VALUE: 'No Discount Ind' },
   { KEY: 'first tvl', VALUE: 'First travel occur' },
   { KEY: 'last tvl', VALUE: 'Last travel occur' },
   { KEY: 'fare ind', VALUE: 'Fare Ind' },
   { KEY: 'percent app', VALUE: 'Percent Application' },
   { KEY: 'fare type', VALUE: 'Base Fare Type' },
   { KEY: 'fare app', VALUE: 'Base Fare App' },
   { KEY: 'book app ind', VALUE: 'Booking App Ind' },
   { KEY: 'bet city code', VALUE: 'Between City Code' },
   { KEY: 'and city code', VALUE: 'AND City Code' },
   { KEY: 'spec fare 1', VALUE: 'Specified Fare 1' },
   { KEY: 'dec 1', VALUE: 'Decimal 1' },
   { KEY: 'spec fare 2', VALUE: 'Specified Fare 2' },
   { KEY: 'dec 2', VALUE: 'Decimal 2' },
   { KEY: 'res owrt', VALUE: 'Resulting OwRt' },
   { KEY: 'res fcc', VALUE: 'Resulting Fare Class' },
   { KEY: 'res bc', VALUE: 'Resulting Booking Code' },
   { KEY: 'tkt code', VALUE: 'Ticketing Code' },
   { KEY: 'tkt code mod', VALUE: 'Ticketing Code Modifier' },
   { KEY: 'tkt des mod', VALUE: 'Ticket designator modifier' },
   { KEY: 'tkt des', VALUE: 'Ticket Designator' },
   { KEY: 'out ind', VALUE: 'Outboud Ind' },
   { KEY: 'same comp', VALUE: 'Same Compartment' },
   { KEY: 'same rule', VALUE: 'Same Rule Ind' },
   { KEY: 'acc pass', VALUE: 'Acc Passenger' },
   { KEY: 'fare book ind', VALUE: 'Fare Booking Ind' },
   { KEY: 'eod', VALUE: 'End Of Record' },
   { KEY: 'no of seg', VALUE: 'No Of Segments' },
   { KEY: 'min no pass', VALUE: 'Min No of Passenger' },
   { KEY: 's. min no pass', VALUE: 'Segment Min No of Passenger' },
   { KEY: 'max no pass', VALUE: 'Max No of Passenger' },
   { KEY: 's. max no pass', VALUE: 'Segment Max No of Passenger' },
   { KEY: 'con ind', VALUE: 'Construction Ind' },
   { KEY: 'pro ind', VALUE: 'Prorate Ind' },
   { KEY: 'diff ind', VALUE: 'Differential Code Ind' },
   { KEY: 'ext ind', VALUE: 'Extension Fare Ind' },
   { KEY: 'group type', VALUE: 'Group Type' },
   { KEY: 'min grp', VALUE: 'Minimum Group Size' },
   { KEY: 'max grp', VALUE: 'Maximum Group Size' },
   { KEY: 'fare class', VALUE: 'Fare Class Type' },
   { KEY: 'flight no', VALUE: 'Flight Number' },
   { KEY: 'val ind', VALUE: 'Validity Ind' },
   { KEY: 'app type', VALUE: 'Application Type' },
   { KEY: 'no of child', VALUE: 'Number of Children' },
   { KEY: 'ch percent', VALUE: 'Child Fare Percentage' },
   { KEY: 'ch fare type', VALUE: 'Child Fare Type' },
   { KEY: 'nm req type', VALUE: 'Name Req Type' },
   { KEY: 'nm period', VALUE: 'Name Period' },
   { KEY: 'nm unit', VALUE: 'Name Unit' },
   { KEY: 'nm app code', VALUE: 'Name Appl Code' },
   { KEY: 'iti', VALUE: 'Itinerary' },
   { KEY: 'pnr', VALUE: 'PNR' },
   { KEY: 'add pass no', VALUE: 'Additional Passenger No' },
   { KEY: 'gr percent', VALUE: 'Group Percentage' },
   { KEY: 'de tod', VALUE: 'Depart Time of day' },
   { KEY: 'el time p', VALUE: 'Elapsed Time Period' },
   { KEY: 'el time u', VALUE: 'Elapsed Time Unit' },
   { KEY: 'add time p', VALUE: 'Additional Time Period' },
   { KEY: 'add time u', VALUE: 'Additional Time Unit' },
   { KEY: 'tkt imm', VALUE: 'Ticketed Immediately' },
   { KEY: 'sub pass no', VALUE: 'No of Substituted Passenger' },
   { KEY: 'max percent', VALUE: 'Maximum Percentage' },
   { KEY: 'sub el time p', VALUE: 'Substitute Elapsed Period' },
   { KEY: 'sub el time u', VALUE: 'Substitute Elapsed Unit' },
   { KEY: 'sub tkt tod', VALUE: 'Sub Ticketing Time of Day' },
   { KEY: 'sub el p', VALUE: 'Sub Elapsed Period' },
   { KEY: 'sub el u', VALUE: 'Sub Unit' },
   { KEY: 'sub tkt imm', VALUE: 'Sub Ticketed Immediately' },
   { KEY: 'min no sec', VALUE: 'Min no of Sectors' },
   { KEY: 'out/in', VALUE: 'Either In or Out' },
   { KEY: 'time app', VALUE: 'Time Applicable' },
   { KEY: 'perm code', VALUE: 'Permitted Code' },
   { KEY: 'out/in/change', VALUE: 'Inbound/Outbound or Changed' },
   { KEY: 'decimal 1', VALUE: 'Decimal 1' },
   { KEY: 'decimal 2', VALUE: 'Decimal 2' },
   { KEY: 'min num pass', VALUE: 'Minimum Number of Passenger' },
   { KEY: 'return', VALUE: 'Return Code' },
   { KEY: 'min tour pass', VALUE: 'Min no of Tour Participants' },
   { KEY: 'max tour pass', VALUE: 'Max no of Tour Participants' },
   { KEY: 'no tour cond', VALUE: 'Number of Tour Conductors' },
   { KEY: 'no pay pass', VALUE: 'Number of Paying Passenger' },
   { KEY: 'max tour cond', VALUE: 'Max no if Tour Conductors' },
   { KEY: 'tvl code', VALUE: 'Travel Code' },
   { KEY: 'diff grp', VALUE: 'Different Groups' },
   { KEY: 'wrt app', VALUE: 'Written Application' },
   { KEY: 'tour type', VALUE: 'Tour Type' },
   { KEY: 'tour no', VALUE: 'Tour Number' },
   { KEY: 'cxr code', VALUE: 'Carrier Code' },
   { KEY: 'no of nights', VALUE: 'Number of Nights' },
   { KEY: 'min amt 1 app', VALUE: 'Min Amount 1 Application' },
   { KEY: 'min amt 1', VALUE: 'Min Amount 1' },
   { KEY: 'add 1 app', VALUE: 'Additional Night 1 App' },
   { KEY: 'add 1 amt', VALUE: 'Additional Amount 1' },
   { KEY: 'min amt 2 app', VALUE: 'Min Amount 2 Application' },
   { KEY: 'min amt 2', VALUE: 'Min Amount 2' },
   { KEY: 'add 2 app', VALUE: 'Additional Night 2 App' },
   { KEY: 'add 2 amt', VALUE: 'Additional Amount 2' },
   { KEY: 'min percent', VALUE: 'Minimum Percent' },
   { KEY: 'min tour amt 1', VALUE: 'Minimum Tour Price 1' },
   { KEY: 'price curr 1', VALUE: 'Currency Code 1' },
   { KEY: 'min tour amt 2', VALUE: 'Minimum Tour Price 2' },
   { KEY: 'tour app code', VALUE: 'Tour Price App Code' },
   { KEY: 'non ref', VALUE: 'Non Refundable Ind' },
   { KEY: 'wav app', VALUE: 'Waiver App Code' },
   { KEY: 'death ind', VALUE: 'Death Ind' },
   { KEY: 'ill ind', VALUE: 'Illness Ind' },
   { KEY: 'sch ch ind', VALUE: 'Schedule Change Ind' },
   { KEY: 'doc den ind', VALUE: 'Document denial Ind' },
   { KEY: 'jury ind', VALUE: 'Jury Duty Ind' },
   { KEY: 'mil ind', VALUE: 'Military Orders Ind' },
   { KEY: 'fare inc ind', VALUE: 'Fare Increase Ind' },
   { KEY: 'pay rec ind', VALUE: 'Payment Received Ind' },
   { KEY: 'min gr amt', VALUE: 'Minimum Ground Amount' },
   { KEY: 'gr curr', VALUE: 'Ground Currency Code' },
   { KEY: 'gr decimal', VALUE: 'Ground Decimal' },
   { KEY: 'gr app', VALUE: 'Minimum Ground Application' },
   { KEY: 'min transfer', VALUE: 'Minimum Transfer Number' },
   { KEY: 'car ren day', VALUE: 'Car Rental Days' },
   { KEY: 'resort day', VALUE: 'Days at Resort' },
   { KEY: 'ship day', VALUE: 'Days on Ship' },
   { KEY: 'oth gr day', VALUE: 'Other Ground Days' },
   { KEY: 'free days', VALUE: 'Consecutive Free Days' },
   { KEY: 'sec 983 id', VALUE: 'Security Table 983 Id' },
   { KEY: 'fare 979 id', VALUE: 'Fare Creator 979 Id' },
   { KEY: 'method type', VALUE: 'Method Type Code' },
   { KEY: 'net/gross', VALUE: 'Net Gross Ind' },
   { KEY: 'comm percent', VALUE: 'Commission Percent' },
   { KEY: 'comm 1 amt', VALUE: 'Commission 1 Amount' },
   { KEY: 'comm 2 amt', VALUE: 'Commission 2 Amount' },
   { KEY: 'ug ind', VALUE: 'Upgrade Ind' },
   { KEY: 'bag no', VALUE: 'Baggage Number' },
   { KEY: 'bag no app', VALUE: 'Baggage No Application' },
   { KEY: 'tkt cxr code', VALUE: 'Ticket Carrier Code' },
   { KEY: 'coupon code', VALUE: 'Coupon Code' },
   { KEY: 'tour code', VALUE: 'Tour Code Type' },
   { KEY: 'tour box', VALUE: 'Tour Box Code' },
   { KEY: 'tkt desg', VALUE: 'Ticket Designator' },
   { KEY: 'tkt fare data', VALUE: 'Ticketed Fare Data' },
   { KEY: 'owrt ind', VALUE: 'OW/RT Ind' },
   { KEY: 'global ind', VALUE: 'Global Ind' },
   { KEY: 'rule no', VALUE: 'Rule Number' },
   { KEY: 'stc', VALUE: 'Season Type Code' },
   { KEY: 'fare box txt', VALUE: 'Fare Box Text' },
   { KEY: 'fare box amt', VALUE: 'Fare Box Amount' },
   { KEY: 'fare box curr', VALUE: 'Fare Box Currency' },
   { KEY: 'fare box dec', VALUE: 'Fare Box Decimal' },
   { KEY: 'and995id', VALUE: 'AND GEO 995 Id' },
   { KEY: 'bet995id', VALUE: 'Between GEO 995 Id' },
   { KEY: 'geo995id', VALUE: 'GEO 995 Id' },
   { KEY: 'gr and995id', VALUE: 'Group AND GEO 995 Id' },
   { KEY: 'gr bet995id', VALUE: 'Group Between GEO 995 Id' },
   { KEY: 'gr to and995id', VALUE: 'Group Tour AND GEO 995 Id' },
   { KEY: 'gr to bet995id', VALUE: 'Group Tour Between GEO 995 Id' },
   { KEY: 'ind and995id', VALUE: 'Individual AND GEO 995 Id' },
   { KEY: 'ind bet995id', VALUE: 'Individual Between GEO 995 Id' },
   { KEY: 'grt', VALUE: 'General Rule Tariff' },
   { KEY: 'grn', VALUE: 'General Rule Number' },
   { KEY: 'genrule', VALUE: 'General Rule Application' },
   { KEY: 'st', VALUE: 'Season Type Code' },
   { KEY: 'typ', VALUE: 'Fare Type Code' },
   { KEY: 'dowt', VALUE: 'Day of Week Type Code' },
   { KEY: 'r type', VALUE: 'Rule Type' },
   { KEY: 'ticket text', VALUE: 'Ticket Text' },
   { KEY: 'org gwt city', VALUE: 'Gateway City Code' },
   { KEY: 'org fcc', VALUE: 'Fare Class Code' },
   { KEY: 'org ft', VALUE: 'Footnote Code' },
   { KEY: 'org tar', VALUE: 'Addon Tariff Number' },
   { KEY: 'org amt', VALUE: 'Addon Amount' },
   { KEY: 'org cur', VALUE: 'Currency Code' },
   { KEY: 'des gwt city', VALUE: 'Gateway City Code' },
   { KEY: 'des fcc', VALUE: 'Fare Class Code' },
   { KEY: 'des ft', VALUE: 'Footnote Code' },
   { KEY: 'des tar', VALUE: 'Addon Tariff Number' },
   { KEY: 'des amt', VALUE: 'Addon Amount' },
   { KEY: 'des cur', VALUE: 'Currency Code' },
   { KEY: 'spec org', VALUE: 'Specified Fare Origin' },
   { KEY: 'spec dest', VALUE: 'Specified Fare Destination' },
   { KEY: 'spec amt', VALUE: 'Specified Fare Amount' },
   { KEY: 'spec curr', VALUE: 'Specified Fare Currency' },
   { KEY: 'tour curr 1', VALUE: 'Currency 1 Code' },
   { KEY: 'tour curr 2', VALUE: 'Currency 2 Code' },
   { KEY: 'tour decimal 1', VALUE: 'Decimal 1' },
   { KEY: 'tour decimal 2', VALUE: 'Decimal 2' },
   { KEY: 'id', VALUE: 'Id' },
   { KEY: 'user ', VALUE: 'User' },
   { KEY: 'last updated', VALUE: 'Last Updated Date' },
   { KEY: 'mkt lst', VALUE: 'Market List Id' },
];

export const TOOL_BAR_BUTTONS = [
   {
      KEY: 'Fares',
   },
   {
      KEY: 'Footnotes',
   },
   {
      KEY: 'Rules',
   },
   {
      KEY: 'Reference',
   },
];
export const OPERATOR_OPTIONS = [
   { label: '=', value: '=' },
   { label: '<>', value: '<>' },
   { label: '>', value: '>' },
   { label: '<', value: '<' },
   { label: '>=', value: '>=' },
   { label: '<=', value: '<=' },
];
export const DISTRIBUTION_OPERATOR_OPTIONS = [
   { label: '=', value: '==' },
   { label: '<>', value: '!=' },
   { label: '>', value: '>' },
   { label: '<', value: '<' },
   { label: '>=', value: '>=' },
   { label: '<=', value: '<=' },
];

export const SEARCH_CRITERIA_CONFIG = [
   {
      categoryName: 'Table',
      screen: 'Fares',
      type: 'Checkbox',
      categoryDetails: [
         { key: 'Active', value: true },
         { key: 'Inactive', value: false },
         { key: 'Historical', value: false },
      ],
   },
   {
      categoryName: 'Products',
      screen: 'Fares',
      type: 'Checkbox',
      categoryDetails: [
         { key: 'Spec', value: true },
         { key: 'Cons', value: false },
         { key: 'Web', value: false },
         { key: 'FBR', value: false },
      ],
   },
   {
      categoryName: 'Search',
      screen: ['Fares'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'MKT LST',
            key: 'marketId',
            operator: '',
            values: '',
         },
      ],
   },
   {
      categoryName: 'Identifier',
      screen: ['Fares'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'ORG',
            key: 'origin',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DES',
            key: 'destination',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CXR',
            key: 'carrier_code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FBC',
            key: 'fareClassCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TAR',
            key: 'tariffNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FT',
            key: 'footnoteCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RTG',
            key: 'routingNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CON',
            key: 'constructionMethod',
            operator: '',
            values: '',
         },
      ],
   },
   {
      categoryName: 'Fare Value',
      screen: ['Fares'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'VCC',
            key: 'vendorChangeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OWRT',
            key: 'roundTripIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CUR',
            key: 'currencyCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AMT',
            key: 'fareAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SUR',
            key: 'surchargeAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'YQ',
            key: 'yqAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'YR',
            key: 'yrAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TAX',
            key: 'aggregatedTax',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TTL',
            key: 'totalFare',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OW AMT',
            key: 'oneWayFareAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RT AMT',
            key: 'roundTripFareAmount',
            operator: '',
            values: '',
         },
      ],
   },
   {
      categoryName: 'Rule',
      screen: ['Fares'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'RULE',
            key: 'ruleNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DOW',
            key: 'dow',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEAS DT',
            key: 'ruleSeasonDates',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AP',
            key: 'advancePurchaseReservation',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RULE TVL DT',
            key: 'ruleTravelDates',
            operator: '',
            values: '',
         },
         {
            keyCode: 'APPL DT',
            key: 'applicableDates',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN ST',
            key: 'minStay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX ST',
            key: 'maxStay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BO DT',
            key: 'ruleBlackOutDates',
            operator: '',
            values: '',
         },
      ],
   },
   {
      categoryName: 'Footnote',
      screen: ['Fares'],
      type: 'DropDownDate',
      categoryDetails: [
         {
            keyCode: 'FST RES',
            key: 'footnoteReservationFromDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LST RES',
            key: 'footnoteReservationToDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FST TKT',
            key: 'footnoteTicketingFromDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LST TKT',
            key: 'footnoteTicketingToDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVL ST',
            key: 'footnoteOutboundTravelFromDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVL END',
            key: 'footnoteOutboundTravelToDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVL CMPLT',
            key: 'footnoteOutboundTravelCompleteDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FT TVL DT',
            key: 'footnoteTravelDates',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FT SEAS DT',
            key: 'footnoteSeasonDates',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FT BO DT',
            key: 'footnoteBlackOutDates',
            operator: '',
            values: '',
         },
      ],
   },
   {
      categoryName: 'Distribution',
      screen: ['Fares'],
      type: 'DropDownDate',
      categoryDetails: [
         {
            keyCode: 'EFF DT',
            key: 'effectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DISC DT',
            key: 'discontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GFS',
            key: 'gfsUniqueFillingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GFS DT',
            key: 'gfsDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UAC',
            key: 'uac',
            operator: '',
            values: '',
         },
         {
            keyCode: 'STATUS',
            key: 'status',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DG',
            key: 'dgNumber',
            operator: '',
            values: '',
         },
      ],
   },
   {
      categoryName: 'Fare Class',
      screen: ['Fares'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'CAB',
            key: 'cabinCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RBD',
            key: 'rbds',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FTC',
            key: 'fareTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DOW TC',
            key: 'dayOfWeekTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEAS TC',
            key: 'seasonTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PTC',
            key: 'passengerTypes',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT DSG',
            key: 'ticketDesignators',
            operator: '',
            values: '',
         },
      ],
   },
   {
      categoryName: 'Brand',
      screen: ['Fares'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'BRD',
            key: 'brand',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BRD DET',
            key: 'branddetails',
            operator: '',
            values: '',
         },
      ],
   },
   {
      categoryName: 'Market',
      screen: ['Fares'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'OC',
            key: 'originCountryCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DC',
            key: 'destinationCountryCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MKT',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SRC',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TIER',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MKT GRP',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MKT TYP',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MKT AST',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MKT CAT',
            operator: '',
            values: '',
         },
      ],
   },
   {
      categoryName: 'Origin Addon',
      screen: ['Fares'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'ORG GWT CITY',
            key: 'gatewayCityCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ORG FCC',
            key: 'fareClassCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ORG FT',
            key: 'footnoteCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ORG TAR',
            key: 'arbTariffNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ORG AMT',
            key: 'fareAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ORG CUR',
            key: 'currencyCode',
            operator: '',
            values: '',
         },
      ],
   },
   {
      categoryName: 'Destination Addon',
      screen: ['Fares'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'DES GWT CITY',
            key: 'gatewayCityCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DES FCC',
            key: 'fareClassCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DES FT',
            key: 'footnoteCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DES TAR',
            key: 'arbTariffNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DES AMT',
            key: 'fareAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DES CUR',
            key: 'currencyCode',
            operator: '',
            values: '',
         },
      ],
   },
   {
      categoryName: 'Specified Fare',
      screen: ['Fares'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'SPEC ORG',
            key: 'specifiedFareOrigin',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SPEC DEST',
            key: 'specifiedFareDestination',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SPEC AMT',
            key: 'specifiedFareAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SPEC CURR',
            key: 'specifiedFareCurrent',
            operator: '',
            values: '',
         },
      ],
   },
   {
      categoryName: 'Table',
      screen: 'Distribution',
      type: 'DropDownGlobalItem',
      categoryDetails: [
         {
            value: '',
            categoryDetails: [
               {
                  label: 'Distribution Group Management',
                  value: 'Distribution Group Management',
               },
               {
                  label: 'Market List',
                  value: 'Market List',
               },
            ],
         },
      ],
   },
   {
      categoryName: 'Distribution Groups',
      screen: ['Distribution'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'DG',
            key: 'dgNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CREATED',
            key: 'createdAt',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST UPDATE',
            key: 'lastUpdatedAt',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DIST DT',
            key: 'distributedAt',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DESCRIPTION',
            key: 'description',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CR USER',
            key: 'user',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE',
            key: 'totalFare',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FTNT',
            key: 'ftnt',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RULE',
            key: 'rule',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADDON',
            key: 'addon',
            operator: '',
            values: '',
         },
         {
            keyCode: 'INT DIST DT',
            key: 'intDistributionTimeStamp',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EX IND',
            key: 'exclusiveAccessIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REL IND',
            key: 'releaseIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'IGN ERR',
            key: 'ignoreErrorsIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LFC',
            key: 'lowFareCheckIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TAX IND',
            key: 'taxIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'JUSTIFICATION',
            key: 'justification',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EMAIL',
            key: 'email',
            operator: '',
            values: '',
         },
         {
            keyCode: 'STATUS',
            key: 'status',
            operator: '',
            values: '',
         },
         {
            keyCode: 'D/I',
            key: 'isDomesticOrInternational',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TIMESTAMP',
            key: 'timestamp',
            operator: '',
            values: '',
         },
         {
            keyCode: 'USER',
            key: 'user',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ACTION',
            key: 'action',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NOTES',
            key: 'notes',
            operator: '',
            values: '',
         },
      ],
   },
   {
      categoryName: 'Market List',
      screen: 'Distribution',
      type: 'DropDownText',
      categoryDetails: [
         { keyCode: 'ID', key: 'marketId', operator: '', values: '' },
         {
            keyCode: 'ORG',
            key: 'origin',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DES',
            key: 'destination',
            operator: '',
            values: '',
         },
         { keyCode: 'USER ', key: 'user', operator: '', values: '' },
         {
            keyCode: 'LAST UPDATED',
            key: 'lastUpdated',
            operator: '',
            values: '',
            disabled: true,
         },
      ],
   },
   {
      categoryName: 'Data',
      screen: ['Footnotes'],
      type: 'RadioButtons',
      categoryDetails: [
         { key: 'Filed', value: false, keyCode: 'Filed' },
         { key: 'Historical', value: false, keyCode: 'Historical' },
         { key: 'Available', value: false, keyCode: 'Available' },
      ],
   },
   {
      categoryName: 'Data',
      screen: ['Rules'],
      type: 'RadioButtons',
      categoryDetails: [
         { key: 'Filed', value: false, keyCode: 'Filed' },
         { key: 'Historical', value: false, keyCode: 'Historical' },
      ],
   },
   {
      categoryName: 'Record 2',
      screen: ['Footnotes'],
      type: 'DropDownText',
      categoryDetails: [
         { keyCode: 'TAR', key: 'fareTariffNumber', operator: '', values: '' },
         { keyCode: 'CXR', key: 'carrier_code', operator: '', values: '' },
         { keyCode: 'FT', key: 'footnoteCode', operator: '', values: '' },
         { keyCode: 'CAT#', key: 'categoryNumber', operator: '', values: '' },
         {
            keyCode: 'CAT NM',
            key: 'categoryNumber',
            operator: '',
            values: '',
            categoryDetails: [
               { label: 'Seasons', value: '03' },
               { label: 'Blackout', value: '11' },
               { label: 'Travel', value: '14' },
               { label: 'Sales', value: '15' },
            ],
         },
         {
            keyCode: 'SEQUENCE',
            key: 'sequenceNumber',
            operator: '',
            values: '',
         },
         { keyCode: 'EFF DT', key: 'effectiveDate', operator: '', values: '' },
         {
            keyCode: 'DISC DT',
            key: 'discontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1 TYPE',
            key: 'location1Type',
            operator: '',
            values: '',
         },
         { keyCode: 'LOC1', key: 'location1Code', operator: '', values: '' },
         {
            keyCode: 'LOC2 TYPE',
            key: 'location2Type',
            operator: '',
            values: '',
         },
         { keyCode: 'LOC2', key: 'location2Code', operator: '', values: '' },
         { keyCode: 'FBC', key: 'fareClassCode', operator: '', values: '' },
         {
            keyCode: 'OWRT',
            key: 'roundTripIndicator',
            operator: '',
            values: '',
         },
         { keyCode: 'RTG', key: 'routingNumber', operator: '', values: '' },
         {
            keyCode: 'NOTAPPL',
            key: 'applicationInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'JT CXR TBL',
            key: 'jointCarrier997Id',
            operator: '',
            values: '',
         },
         { keyCode: 'SEGS', key: 'segmentCount', operator: '', values: '' },
         { keyCode: 'FARES', key: 'fares', operator: '', values: '' },
         { keyCode: 'ACT', key: 'actionCode', operator: '', values: '' },
         { keyCode: 'BATCH CODE', key: 'batchCode', operator: '', values: '' },
         { keyCode: 'BATCH NUM', key: 'batchNumber', operator: '', values: '' },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
         { keyCode: 'FT TYPE', key: 'product_type', operator: '', values: '' },
         { keyCode: 'S', key: 'footnoteStateCode', operator: '', values: '' },
         {
            keyCode: 'DIST GRP',
            key: 'distributionGroup',
            operator: '',
            values: '',
         },
         { keyCode: 'USER', key: 'user', operator: '', values: '' },
         { keyCode: 'CHG DT', key: 'changeDate', operator: '', values: '' },
         { keyCode: 'CHG USER', key: 'changeUser', operator: '', values: '' },
      ],
   },
   {
      categoryName: 'Record 2',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'TAR',
            key: 'ruleTariffNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CXR',
            key: 'carrier_code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CAT#',
            key: 'categoryNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CAT NM',
            key: 'categoryNumber',
            operator: '',
            values: '',
            categoryDetails: [
               { label: 'Eligibility', value: '01' },
               { label: 'Day Time', value: '02' },
               { label: 'Seasons', value: '03' },
               { label: 'Flight Application', value: '04' },
               { label: 'Advance Purchase', value: '05' },
               { label: 'Minimum Stay', value: '06' },
               { label: 'Maximum Stay', value: '07' },
               { label: 'Stopover', value: '08' },
               { label: 'Transfers', value: '09' },
               { label: 'Blackout', value: '11' },
               { label: 'Surcharges', value: '12' },
               { label: 'Accompanied Travel', value: '13' },
               { label: 'Travel Restrictions', value: '14' },
               { label: 'Sales Restrictions', value: '15' },
               { label: 'Penalties', value: '16' },
               { label: 'Higher Intermediate Points', value: '17' },
               { label: 'Ticket Endorsements', value: '18' },
               { label: 'Children Discounts', value: '19' },
               { label: 'Tour Conductor Discount', value: '20' },
               { label: 'Agent Discount', value: '21' },
               { label: 'Other Discount', value: '22' },
               { label: 'Miscellaneous Fare Tags', value: '23' },
               { label: 'Groups', value: '26' },
               { label: 'Tours', value: '27' },
               { label: 'Visit Another Country', value: '28' },
               { label: 'Deposits', value: '29' },
               { label: 'Voluntary Changes', value: '31' },
               { label: 'Voluntary Refunds', value: '33' },
               { label: 'Negotiated Fare', value: '35' },
               { label: 'Rule Application', value: '50' },
            ],
         },
         {
            keyCode: 'SEQUENCE',
            key: 'sequenceNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RULE',
            key: 'ruleNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EFF DT',
            key: 'effectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DISC DT',
            key: 'discontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1 TYPE',
            key: 'location1Type',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2 TYPE',
            key: 'location2Type',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FBC',
            key: 'fareClassCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FT',
            key: 'footnoteCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OWRT',
            key: 'roundTripIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RTG',
            key: 'routingNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DOWT',
            key: 'dayOfWeekType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TYP',
            key: 'fareType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ST',
            key: 'seasonType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GENRULE',
            key: 'generalRuleInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GRN',
            key: 'generalRuleNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GRT',
            key: 'generalRuleTariffNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NOTAPPL',
            key: 'applicationInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'JT CXR TBL',
            key: 'jointCarrier997Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEGS',
            key: 'segmentCount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ACT',
            key: 'actionCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BATCH CODE',
            key: 'batchCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BATCH NUM',
            key: 'batchNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
         {
            keyCode: 'R TYPE',
            key: 'product_type',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S',
            key: 'footnoteStateCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DIST GRP',
            key: 'product_type',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CHG USER',
            key: 'product_type',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CHG DT',
            key: 'product_type',
            operator: '',
            values: '',
         },
      ],
   },
   {
      categoryName: 'Record 2 Segments',
      screen: ['Footnotes', 'Rules'],
      type: 'DropDownText',
      categoryDetails: [
         { keyCode: 'REL', key: 'relationalInd', operator: '', values: '' },
         { keyCode: 'IO', key: 'inOutboundInd', operator: '', values: '' },
         { keyCode: 'DIR', key: 'directionalInd', operator: '', values: '' },
         { keyCode: 'CAT#', key: 'categoryNumber', operator: '', values: '' },
         { keyCode: 'REC3ID', key: 'record3TableId', operator: '', values: '' },
         { keyCode: 'SEG', key: 'segmentNumber', operator: '', values: '' },
      ],
   },
   {
      categoryName: '01 - Eligibility',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'PTC',
            key: 'passengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX AGE',
            key: 'maximumAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AGE',
            key: 'minimumAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PSC',
            key: 'passengerStatusCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AC',
            key: 'accountCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'APP IND',
            key: 'applicationInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST OCC',
            key: 'firstOccurrence',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST OCC',
            key: 'lastOccurrence',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ID REQ IND',
            key: 'idRequirementInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC CODE',
            key: 'locationCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC TYPE',
            key: 'locationTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '01',
   },
   {
      categoryName: '02 - Day Time',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'DOW',
            key: 'daysOfWeek',
            operator: '',
            values: '',
         },
         {
            keyCode: 'START TOD',
            key: 'startTimeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'STOP TOD',
            key: 'stopTimeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TOD IND',
            key: 'timeApplicationCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RET OCCUR',
            key: 'returnDayOccurrence',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RET IND',
            key: 'returnSameDayInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'APP IND',
            key: 'applicationTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NEG IND',
            key: 'negateTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GEO 995',
            key: 'geographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '02',
   },
   {
      categoryName: '03 - Seasons',
      screen: ['Footnotes', 'Rules'],
      type: 'DropDownText',
      categoryDetails: [
         { keyCode: 'OVR IND', key: 'overrideInd', operator: '', values: '' },
         {
            keyCode: 'SEA TYP',
            key: 'seasonTypeCode',
            operator: '',
            values: '',
         },
         { keyCode: 'SEA ST', key: 'startDate', operator: '', values: '' },
         { keyCode: 'SEA END', key: 'stopDate', operator: '', values: '' },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GEO 995',
            key: 'geographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         { keyCode: 'TEXT 996', key: 'text996Id', operator: '', values: '' },
         { keyCode: 'TEXT', key: 'lineText', operator: '', values: '' },
         { keyCode: 'UVD', key: 'unavailableTag', operator: '', values: '' },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '03',
   },
   {
      categoryName: '04 - Flight Application',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'APP IND',
            key: 'applicationInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FLIGHT NO 1',
            key: 'flightNumber1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CXR CODE 1',
            key: 'carrierCode1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CXR 1 986 ID',
            key: 'carrier1FlightTable986Id',
            operator: '',
            values: '',
         },

         {
            keyCode: 'FLT NO 1',
            key: 'carrierFlight986FlightNumber1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FLT NO 2',
            key: 'carrierFlight986FlightNumber2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MKT CXR',
            key: 'carrierFlight986MarketingCarrier',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OP CXR',
            key: 'carrierFlight986OperatingCarrier',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REL IND 1',
            key: 'relationalInd1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FLIGHT NO 2',
            key: 'flightNumber2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CXR CODE 2',
            key: 'carrierCode2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CXR 2 986 ID',
            key: 'carrier2FlightTable986Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REL IND 2',
            key: 'relationalInd2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FLIGHT NO 3',
            key: 'flightNumber3',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CXR CODE 3',
            key: 'carrierCode3',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DOW IND',
            key: 'dayOfWeekInds',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DIR IND',
            key: 'directionalInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC VAL IND',
            key: 'locationValidityInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC CODE IND',
            key: 'locationCodeInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'VIA IND',
            key: 'viaInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'HID IND',
            key: 'hiddenInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NON STOP IND',
            key: 'nonStopInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DIRECT IND',
            key: 'directInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MUL STOP IND',
            key: 'multiStopInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ONE STOP IND',
            key: 'oneStopInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ONLINE IND',
            key: 'onlineConnectInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'INTER IND',
            key: 'interlineConnectInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME IND',
            key: 'sameFlightInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EQP CODE IND',
            key: 'equipmentCodeInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EQP CODE',
            key: 'equipmentCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND GEO 995',
            key: 'andTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND LOCTYP',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND LOC1',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND LOC2',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND TSI',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET GEO 995',
            key: 'betweenTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET LOCTYP',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET LOC1',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET LOC2',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET TSI',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'VIA GEO 995',
            key: 'viaTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'VIA LOCTYP',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'VIA LOC1',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'VIA LOC2',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'VIA TSI',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '04',
   },
   {
      categoryName: '05 - Advance Purchase',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'FIRST TOD',
            key: 'firstTimeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST P',
            key: 'firstPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST U',
            key: 'firstUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST TOD',
            key: 'lastTimeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST P',
            key: 'lastPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST U',
            key: 'lastUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OTH RES IND',
            key: 'otherRestrictionIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'IMM TKT IND',
            key: 'immediateTicketingInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NOT PERM IND',
            key: 'notPermittedInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAIT CODE',
            key: 'waitListCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEG CODE',
            key: 'segmentConfirmedCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EACH SEG IND',
            key: 'eachSegmentInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT TOD',
            key: 'ticketTimeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT P',
            key: 'ticketPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT U',
            key: 'ticketUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEPART OP CODE',
            key: 'departureOptionCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TIME DEPART',
            key: 'timeBeforeDeparture',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEPART U',
            key: 'departureUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TSI',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BOTH CODE',
            key: 'bothCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EXC TIME',
            key: 'exceptionTime',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EXC UNIT',
            key: 'exceptionUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES DATE',
            key: 'reservationDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT DATE',
            key: 'ticketDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GEO 995',
            key: 'geographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '05',
   },
   {
      categoryName: '06 - Minimum Stay',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'MIN STAY P',
            key: 'minimumStayPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN STAY U',
            key: 'minimumStayUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DOW IND',
            key: 'dayOfWeekInds',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TOD',
            key: 'timeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAV CODE',
            key: 'waiverCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'E/L CODE',
            key: 'earlierLaterCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN STAY D',
            key: 'minimumStayDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAV DATE',
            key: 'waiverDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAV E/L',
            key: 'waiverEarlierLaterCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAV P',
            key: 'waiverPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAV U',
            key: 'waiverUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'APP CODE',
            key: 'applicationCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'G MIL',
            key: 'greaterMileage',
            operator: '',
            values: '',
         },
         {
            keyCode: 'L MIL',
            key: 'lesserMileage',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FROM GEO 995',
            key: 'fromGeographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FROM LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FROM LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FROM LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FROM TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TO GEO 995',
            key: 'toGeographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TO LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TO LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TO LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TO TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '06',
   },
   {
      categoryName: '07 - Maximum Stay',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'MAXSTAYP',
            key: 'maximumStayPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAXSTAYU',
            key: 'maximumStayUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RET CODE',
            key: 'returnTravelCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TOD',
            key: 'timeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT IND',
            key: 'ticketIssuanceInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'E/L CODE',
            key: 'earlierLaterCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX STAY D',
            key: 'maximumStayDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAV CODE',
            key: 'waiverCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAV DATE',
            key: 'waiverDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAV E/L',
            key: 'waiverEarlierLaterCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAV P',
            key: 'waiverPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAV U',
            key: 'waiverUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FROM GEO 995',
            key: 'fromGeographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FROM LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FROM LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FROM LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FROM TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TO GEO 995',
            key: 'toGeographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TO LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TO LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TO LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TO TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '07',
   },
   {
      categoryName: '08 - Stopover',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'MIN NUM',
            key: 'minimumNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX NUM',
            key: 'maximumNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OUT NUM',
            key: 'outboundNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'IN NUM',
            key: 'inboundNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NOT BOTH IND',
            key: 'notBothInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OPEN JAW',
            key: 'openJawInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CIRCLE TRIP',
            key: 'circleTrip2Ind',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CIRCLE T PL',
            key: 'circleTrip2PlusInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GATE PERM',
            key: 'gatewayPermittedCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN TIME P',
            key: 'minimumTimePeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN TIME U',
            key: 'minimumTimeUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX TIME P',
            key: 'maximumTimePeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX TIME U',
            key: 'maximumTimeUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME STOP',
            key: 'samePointStopovers',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME TRANSITS',
            key: 'samePointTransits',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME CONNECT',
            key: 'samePointConnections',
            operator: '',
            values: '',
         },
         {
            keyCode: 'APP 1 IND',
            key: 'application1Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST AMT NUM',
            key: 'firstAmount1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST AMT',
            key: 'firstAmount1Int',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADD AMT 1 NUM',
            key: 'additionalAmount1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADD AMT 1',
            key: 'additionalAmount1Int',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 1 CODE',
            key: 'currency1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 1 NO',
            key: 'decimalPlace1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST AMT 2',
            key: 'firstAmount2Int',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADD AMT 2',
            key: 'additionalAmount2Int',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 2 CODE',
            key: 'currency2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 2 NO',
            key: 'decimalPlace2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEG NUM',
            key: 'numberOfSegments',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME CXR CODE',
            key: 'cat8SegSameCarrierCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'STOP NUM',
            key: 'cat8SegNumberOfStopover',
            operator: '',
            values: '',
         },
         {
            keyCode: 'IN CXR',
            key: 'cat8SegInboundCarrierCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'APP CODE',
            key: 'cat8SegApplicationCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC TYPE',
            key: 'cat8SegLocationTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC 1 CODE',
            key: 'cat8SegLocation1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC 2 CODE',
            key: 'cat8SegLocation2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OUT CXR',
            key: 'cat8SegOutboundCarrierCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'I/O',
            key: 'cat8SegInboundOutboundCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CHARGE CODE',
            key: 'cat8SegChargeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GEO 995',
            key: 'gatewayTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
         {
            keyCode: 'POINT 993',
            key: 'samePoints993Id',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '08',
   },
   {
      categoryName: '09 - Transfers',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'MIN',
            key: 'minNumberOfTransfers',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX',
            key: 'maxNumberOfTransfers',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PRM',
            key: 'prmTransferCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX PRM',
            key: 'maxNumberOfPRMTransfers',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SME',
            key: 'smeTransferCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX SME',
            key: 'maxNumberOfSMETransfers',
            operator: '',
            values: '',
         },
         {
            keyCode: 'INTERLINE',
            key: 'interlineTransferCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX INTER',
            key: 'maxNumberOfInterlineTransfers',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OTH CXR',
            key: 'otherCarrierTransferCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX OTH CXR',
            key: 'maxNumberOfOtherCarrierTransfers',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OUT',
            key: 'outboundTransfersPermitted',
            operator: '',
            values: '',
         },
         {
            keyCode: 'IN',
            key: 'inboundTransfersPermitted',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OR',
            key: 'outboundOrReturnPermitCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SURF TAG',
            key: 'surfTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SURF 976 ID',
            key: 'surfTable976Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EMB TAG',
            key: 'embTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EMB 976 ID',
            key: 'embeddedSurfTable976Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'APPL',
            key: 'transferChargesIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CHARGE 1 NO',
            key: 'maxTransfersAssessed',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CHARGE 1 AMT',
            key: 'charge1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CHARGE 2 NO',
            key: 'maxTransfersCharged',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CHARGE 2 AMT',
            key: 'charge2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 1',
            key: 'currencyCode1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC NO 1',
            key: 'decimalPlace1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CHARGE 3 AMT',
            key: 'charge3',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CHARGE 4 AMT',
            key: 'charge4',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 2',
            key: 'currencyCode2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC NO 2',
            key: 'decimalPlace2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO OF SEGS',
            key: 'numberOfSegments',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TRAN APPL',
            key: 'cat9SegTransferApplication',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NUM',
            key: 'cat9SegTransferNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PRIMARY',
            key: 'cat9SegTransferPrm',
            operator: '',
            values: '',
         },
         {
            keyCode: 'T SME',
            key: 'cat9SegTransferSme',
            operator: '',
            values: '',
         },
         {
            keyCode: 'T OTH CXR',
            key: 'cat9SegTransferPrmOth',
            operator: '',
            values: '',
         },
         {
            keyCode: 'T INTERLINE',
            key: 'cat9SegTransferInterline',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CNX OR STOP',
            key: 'cat9SegConnectionOrStopoverPoint',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CXR APP CODE',
            key: 'cat9SegCarrierApplicationCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'IN CXR CODE',
            key: 'cat9SegInCarrierCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'IN CXR 990 ID',
            key: 'cat9SegInCarrierTable990Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OUT CXR CODE',
            key: 'cat9SegOutCarrierCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OUT CXR 990 ID',
            key: 'cat9SegOutCarrierTable990Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TSI',
            key: 'cat9SegTravelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TYPE CODE',
            key: 'cat9SegTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC 1 CODE',
            key: 'cat9SegLocation1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC 2 CODE',
            key: 'cat9SegLocation2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC 978 ID',
            key: 'cat9SegLocation1Zone978Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET LOC',
            key: 'cat9SegBetween',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GATEWAY',
            key: 'cat9SegGateway',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESTRICTION',
            key: 'cat9SegRestriction',
            operator: '',
            values: '',
         },
         {
            keyCode: 'POR IND',
            key: 'cat9SegPortionIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TRANSFER',
            key: 'cat9SegTransferCharge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '09',
   },
   {
      categoryName: '11 - Blackout',
      screen: ['Footnotes', 'Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'APP IND',
            key: 'applicationInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'INT CON WV',
            key: 'intConnectionInd',
            operator: '',
            values: '',
         },
         { keyCode: 'BLACKOUT ST', key: 'startDate', operator: '', values: '' },
         { keyCode: 'BLACKOUT END', key: 'stopDate', operator: '', values: '' },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND GEO 995',
            key: 'andTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET GEO 995',
            key: 'betweenTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         { keyCode: 'TEXT 996', key: 'text996Id', operator: '', values: '' },
         { keyCode: 'TEXT', key: 'lineText', operator: '', values: '' },
         { keyCode: 'UVD', key: 'unavailableTag', operator: '', values: '' },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '11',
   },

   {
      categoryName: '12 - Surcharges',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'START P',
            key: 'startPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'STOP P',
            key: 'stopPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST TOD',
            key: 'firstTimeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST TOD',
            key: 'lastTimeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TOD APP IND',
            key: 'timeOfDayApplicationInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DOW IND',
            key: 'dayOfWeekInds',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SUR TYPE',
            key: 'surchargeType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EQP CODE',
            key: 'equipmentCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVL POR IND',
            key: 'travelPortionInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEC POR IND',
            key: 'sectorPortionInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'APP CODE',
            key: 'applicationCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SUR 1 AMT',
            key: 'surcharge1Amount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 1 CODE',
            key: 'currency1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SUR 2 AMT',
            key: 'surcharge2Amount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 2 CODE',
            key: 'currency2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PERCENT',
            key: 'percent',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PER APP CODE',
            key: 'percentApplicationCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RBD',
            key: 'reservationBookingDesignator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FLIGHT 986 ID',
            key: 'carrierFlight986Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FLT NO 1',
            key: 'carrierFlight986FlightNumber1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FLT NO 2',
            key: 'carrierFlight986FlightNumber2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MKT CXR',
            key: 'carrierFlight986MarketingCarrier',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OP CXR',
            key: 'carrierFlight986OperatingCarrier',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GEO 995',
            key: 'geographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET GEO 995',
            key: 'betweenTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET LOCTYP',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET LOC2',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET TSI',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND GEO 995',
            key: 'andTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND LOCTYP',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND LOC1',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND LOC2',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND TSI',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '12',
   },
   {
      categoryName: '13 - Accompanied Travel',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'ALL SEC IND',
            key: 'allSectorsInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OUT JRNY IND',
            key: 'outboundJourneyInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ONE SEC IND',
            key: 'atLeastOneSectorInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME COM IND',
            key: 'sameCompartmentInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME RUL IND',
            key: 'sameRuleInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ACC PASS IND',
            key: 'accompanyingPassengerInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PTC',
            key: 'passengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ID REQ IND',
            key: 'idRequirementInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AGE',
            key: 'minimumAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX AGE',
            key: 'maximumAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN NUM',
            key: 'minimumNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX NUM',
            key: 'maximumNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE BOOK',
            key: 'fareBookingInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEG NUM',
            key: 'numberOfSegments',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FBC',
            key: 'cat13SegFareClassBookingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '13',
   },
   {
      categoryName: '14 - Travel Restrictions',
      screen: ['Footnotes', 'Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'TVL ST',
            key: 'commenceFromDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVL END',
            key: 'commenceToDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVL CMPLT',
            key: 'completeDate',
            operator: '',
            values: '',
         },
         { keyCode: 'RI', key: 'completeInd', operator: '', values: '' },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GEO 995',
            key: 'geographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         { keyCode: 'TEXT 996', key: 'text996Id', operator: '', values: '' },
         { keyCode: 'TEXT', key: 'lineText', operator: '', values: '' },
         { keyCode: 'RET TM', key: 'timeOfDay', operator: '', values: '' },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
         { keyCode: 'UVD', key: 'unavailableTag', operator: '', values: '' },
      ],
      categoryCode: '14',
   },
   {
      categoryName: '15 - Sales Restrictions',
      screen: ['Footnotes', 'Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'FST TKT',
            key: 'ticketingFromDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LST TKT',
            key: 'ticketingToDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FST RES',
            key: 'reservationFromDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LST RES',
            key: 'reservationToDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCTYP',
            key: 'cat15SegLocationTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1',
            key: 'cat15SegLocation1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2',
            key: 'cat15SegLocation2Code',
            operator: '',
            values: '',
         },
         { keyCode: 'TEXT 996', key: 'text996Id', operator: '', values: '' },
         { keyCode: 'TEXT', key: 'lineText', operator: '', values: '' },
         { keyCode: 'UVD', key: 'unavailableTag', operator: '', values: '' },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '15',
   },
   {
      categoryName: '16 - Penalties',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'VOL IND',
            key: 'voluntaryInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'INVOL IND',
            key: 'involuntaryInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CAN REF',
            key: 'cancellationsInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT REF',
            key: 'ticketRefundCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CAN IND',
            key: 'cancelInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FAIL IND',
            key: 'failureInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REISSUE IND',
            key: 'reissueInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REPLACE IND',
            key: 'replaceInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CHANGE IND',
            key: 'changeInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PTA IND',
            key: 'ptaInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REFUND IND',
            key: 'refundInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'APP CODE',
            key: 'applicationCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'POR CODE',
            key: 'portionCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PENALTY 1 AMT',
            key: 'penalty1Amount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 1 CODE',
            key: 'currency1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PENALTY 2 AMT',
            key: 'penalty2Amount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 2 CODE',
            key: 'currency2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PERCENT',
            key: 'percent',
            operator: '',
            values: '',
         },
         {
            keyCode: 'H/L IND',
            key: 'highLowCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEA WAV IND',
            key: 'deathInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ILL WAV IND',
            key: 'illnessInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'F DEA WAV IND',
            key: 'familyDeathInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'F ILL WAV IND',
            key: 'familyIllnessInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SCH C IND',
            key: 'scheduleChangeInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT UG IND',
            key: 'ticketUpgradeInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GEO 995',
            key: 'geographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '16',
   },
   {
      categoryName: '17 - Higher Intermediate Points',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'LOC TYPE CODE',
            key: 'locationTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC 1 CODE',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC 2 CODE',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CXN STOP',
            key: 'connectionOrStopOverPoint',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO HIP',
            key: 'noHipCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '17',
   },
   {
      categoryName: '18 - Ticket Endorsements',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'TICKET TEXT',
            key: 'text',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC CODE',
            key: 'locationCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '18',
   },
   {
      categoryName: '19 - Children Discounts',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'NO DISC IND',
            key: 'noDiscountInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PTC',
            key: 'passengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ID REQ IND',
            key: 'idRequirementInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AGE',
            key: 'minimumAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX AGE',
            key: 'maximumAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST TVL',
            key: 'firstTravelOccurrence',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST TVL',
            key: 'lastTravelOccurrence',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE IND',
            key: 'fareInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PERCENT APP',
            key: 'percentApplication',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OWRT',
            key: 'owRtInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE TYPE',
            key: 'baseFareType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE APP',
            key: 'baseFareApplication',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BOOK APP IND',
            key: 'bookingApplicationInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BOOK CODE',
            key: 'bookingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET CITY CODE',
            key: 'betweenCityCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND CITY CODE',
            key: 'andCityCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SPEC FARE 1',
            key: 'specifiedFare1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 1',
            key: 'currency1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 1',
            key: 'decimal1Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SPEC FARE 2',
            key: 'specifiedFare2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 2',
            key: 'currency2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 2',
            key: 'decimal2Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES OWRT',
            key: 'resultingOwRtInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES FCC',
            key: 'resultingFareClass',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES BC',
            key: 'resultingBookingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT CODE',
            key: 'ticketingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT CODE MOD',
            key: 'ticketingCodeModifier',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT DES',
            key: 'ticketDesignator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT DES MOD',
            key: 'ticketDesignatorModifier',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ALL SEC IND',
            key: 'allSectorsInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OUT IND',
            key: 'outboundJourneyInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ONE SEC IND',
            key: 'atLeastOneSectorInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME COMP',
            key: 'sameCompartmentInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME RULE',
            key: 'sameRuleInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ACC PASS',
            key: 'accompanyingPassengerInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE BOOK IND',
            key: 'fareBookingInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EOD',
            key: 'endOfRecordInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO OF SEG',
            key: 'noOfSegments',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MIN NO PASS',
            key: 'cat19SegMinNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MAX NO PASS',
            key: 'cat19SegMaxNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. PTC',
            key: 'cat19SegPassengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MAX AGE',
            key: 'cat19SegMaxAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MIN AGE',
            key: 'cat19SegMinAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. FCC',
            key: 'cat19SegFareClassCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GEO 995',
            key: 'geographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '19',
   },
   {
      categoryName: '20 - Tour Conductor Discount',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'NO DISC IND',
            key: 'noDiscountInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PTC',
            key: 'passengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ID REQ IND',
            key: 'idRequirementInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AGE',
            key: 'minimumAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX AGE',
            key: 'maximumAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST TVL',
            key: 'firstTravelOccurrence',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST TVL',
            key: 'lastTravelOccurrence',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE IND',
            key: 'fareInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PERCENT APP',
            key: 'percentApplication',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OWRT',
            key: 'owRtInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE TYPE',
            key: 'baseFareType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE APP',
            key: 'baseFareApplication',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BOOK APP IND',
            key: 'bookingApplicationInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BOOK CODE',
            key: 'bookingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET CITY CODE',
            key: 'betweenCityCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND CITY CODE',
            key: 'andCityCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SPEC FARE 1',
            key: 'specifiedFare1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 1',
            key: 'currency1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 1',
            key: 'decimal1Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SPEC FARE 2',
            key: 'specifiedFare2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 2',
            key: 'currency2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 2',
            key: 'decimal2Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES OWRT',
            key: 'resultingOwRtInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES FCC',
            key: 'resultingFareClass',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES BC',
            key: 'resultingBookingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT CODE',
            key: 'ticketingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT CODE MOD',
            key: 'ticketingCodeModifier',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT DES',
            key: 'ticketDesignator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT DES MOD',
            key: 'ticketDesignatorModifier',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ALL SEC IND',
            key: 'allSectorsInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OUT IND',
            key: 'outboundJourneyInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ONE SEC IND',
            key: 'atLeastOneSectorInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME COMP',
            key: 'sameCompartmentInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME RULE',
            key: 'sameRuleInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ACC PASS',
            key: 'accompanyingPassengerInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE BOOK IND',
            key: 'fareBookingInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EOD',
            key: 'endOfRecordInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO OF SEG',
            key: 'noOfSegments',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MIN NO PASS',
            key: 'cat20SegMinNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MAX NO PASS',
            key: 'cat20SegMaxNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. PTC',
            key: 'cat20SegPassengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MAX AGE',
            key: 'cat20SegMaxAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MIN AGE',
            key: 'cat20SegMinAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. FCC',
            key: 'cat20SegFareClassCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GEO 995',
            key: 'geographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '20',
   },
   {
      categoryName: '21 - Agent Discount',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'NO DISC IND',
            key: 'noDiscountInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PTC',
            key: 'passengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ID REQ IND',
            key: 'idRequirementInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AGE',
            key: 'minimumAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX AGE',
            key: 'maximumAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST TVL',
            key: 'firstTravelOccurrence',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST TVL',
            key: 'lastTravelOccurrence',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE IND',
            key: 'fareInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PERCENT APP',
            key: 'percentApplication',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OWRT',
            key: 'owRtInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE TYPE',
            key: 'baseFareType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE APP',
            key: 'baseFareApplication',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BOOK APP IND',
            key: 'bookingApplicationInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BOOK CODE',
            key: 'bookingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET CITY CODE',
            key: 'betweenCityCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND CITY CODE',
            key: 'andCityCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SPEC FARE 1',
            key: 'specifiedFare1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 1',
            key: 'currency1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 1',
            key: 'decimal1Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SPEC FARE 2',
            key: 'specifiedFare2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 2',
            key: 'currency2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 2',
            key: 'decimal2Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES OWRT',
            key: 'resultingOwRtInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES FCC',
            key: 'resultingFareClass',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES BC',
            key: 'resultingBookingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT CODE',
            key: 'ticketingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT CODE MOD',
            key: 'ticketingCodeModifier',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT DES',
            key: 'ticketDesignator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT DES MOD',
            key: 'ticketDesignatorModifier',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ALL SEC IND',
            key: 'allSectorsInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OUT IND',
            key: 'outboundJourneyInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ONE SEC IND',
            key: 'atLeastOneSectorInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME COMP',
            key: 'sameCompartmentInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME RULE',
            key: 'sameRuleInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ACC PASS',
            key: 'accompanyingPassengerInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE BOOK IND',
            key: 'fareBookingInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EOD',
            key: 'endOfRecordInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO OF SEG',
            key: 'noOfSegments',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MIN NO PASS',
            key: 'cat21SegMinNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MAX NO PASS',
            key: 'cat21SegMaxNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. PTC',
            key: 'cat21SegPassengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MAX AGE',
            key: 'cat21SegMaxAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MIN AGE',
            key: 'cat21SegMinAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. FCC',
            key: 'cat21SegFareClassCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GEO 995',
            key: 'geographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '21',
   },
   {
      categoryName: '22 - Other Discount',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'NO DISC IND',
            key: 'noDiscountInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PTC',
            key: 'passengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ID REQ IND',
            key: 'idRequirementInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AGE',
            key: 'minimumAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX AGE',
            key: 'maximumAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST TVL',
            key: 'firstTravelOccurrence',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST TVL',
            key: 'lastTravelOccurrence',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE IND',
            key: 'fareInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PERCENT APP',
            key: 'percentApplication',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OWRT',
            key: 'owRtInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE TYPE',
            key: 'baseFareType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE APP',
            key: 'baseFareApplication',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BOOK APP IND',
            key: 'bookingApplicationInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BOOK CODE',
            key: 'bookingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET CITY CODE',
            key: 'betweenCityCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND CITY CODE',
            key: 'andCityCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SPEC FARE 1',
            key: 'specifiedFare1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 1',
            key: 'currency1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 1',
            key: 'decimal1Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SPEC FARE 2',
            key: 'specifiedFare2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 2',
            key: 'currency2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 2',
            key: 'decimal2Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES OWRT',
            key: 'resultingOwRtInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES FCC',
            key: 'resultingFareClass',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES BC',
            key: 'resultingBookingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT CODE',
            key: 'ticketingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT CODE MOD',
            key: 'ticketingCodeModifier',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT DES',
            key: 'ticketDesignator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT DES MOD',
            key: 'ticketDesignatorModifier',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ALL SEC IND',
            key: 'allSectorsInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OUT IND',
            key: 'outboundJourneyInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ONE SEC IND',
            key: 'atLeastOneSectorInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME COMP',
            key: 'sameCompartmentInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME RULE',
            key: 'sameRuleInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ACC PASS',
            key: 'accompanyingPassengerInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE BOOK IND',
            key: 'fareBookingInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EOD',
            key: 'endOfRecordInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO OF SEG',
            key: 'noOfSegments',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MIN NO PASS',
            key: 'cat22SegMinNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MAX NO PASS',
            key: 'cat22SegMaxNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. PTC',
            key: 'cat22SegPassengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MAX AGE',
            key: 'cat22SegMaxAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. MIN AGE',
            key: 'cat22SegMinAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'S. FCC',
            key: 'cat22SegFareClassCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GEO 995',
            key: 'geographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCTYP 995',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1 995',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2 995',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TSI 995',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '22',
   },
   {
      categoryName: '23 - Miscellaneous Fare Tags',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'CON IND',
            key: 'constructionFareCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PRO IND',
            key: 'prorateCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DIFF IND',
            key: 'differentialCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EXT IND',
            key: 'proportionalInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '23',
   },
   {
      categoryName: '26 - Groups',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'GROUP TYPE',
            key: 'groupType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN GRP',
            key: 'minGroupSize',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX GRP',
            key: 'maxGroupSize',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE CLASS',
            key: 'fareClassType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FLIGHT NO',
            key: 'flightNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'VAL IND',
            key: 'validityIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'APP TYPE',
            key: 'applicationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO OF CHILD',
            key: 'numberOfChildren',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CH PERCENT',
            key: 'childFarePercentage',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FCC',
            key: 'fareClassCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CH FARE TYPE',
            key: 'childFareType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NM REQ TYPE',
            key: 'reqType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TOD',
            key: 'timeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NM PERIOD',
            key: 'namePeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NM UNIT',
            key: 'nameUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NM APP CODE',
            key: 'nameApplCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ITI',
            key: 'itinerary',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PNR',
            key: 'pnr',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE CODE',
            key: 'fareCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADD PASS NO',
            key: 'additionalPassengers',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GR PERCENT',
            key: 'totalGroupPercent',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DE TOD',
            key: 'departTimeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EL TIME P',
            key: 'elapsedTimePeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'EL TIME U',
            key: 'precedingPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT TOD',
            key: 'ticketingTimeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADD TIME P',
            key: 'additionalPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADD TIME U',
            key: 'unit1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT IMM',
            key: 'imm1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SUB PASS NO',
            key: 'maxSubstitutePassengers',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX PERCENT',
            key: 'maxPercent',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST TOD',
            key: 'lastTimeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SUB EL TIME P',
            key: 'elapsedPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SUB EL TIME U',
            key: 'unit2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SUB TKT TOD',
            key: 'lastTicketingTimeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SUB EL P',
            key: 'period',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SUB EL U',
            key: 'unit3',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SUB TKT IMM',
            key: 'imm2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN NO SEC',
            key: 'minNumberOfSectors',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OUT',
            key: 'outbound',
            operator: '',
            values: '',
         },
         {
            keyCode: 'IN',
            key: 'inbound',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OUT/IN',
            key: 'inboundOrOutbound',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TIME APP',
            key: 'timeFrameCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAV CODE',
            key: 'waiverCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PERM CODE',
            key: 'permitCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME CXR CODE',
            key: 'sameCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OUT/IN/CHANGE',
            key: 'inboundOrOutboundOrChanged',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADD AMT 1',
            key: 'additionalAmount1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 1',
            key: 'currencyCode1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DECIMAL 1',
            key: 'decimalPlace1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADD AMT 2',
            key: 'additionalAmount2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 2',
            key: 'currencyCode2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DECIMAL 2',
            key: 'decimalPlace2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN NUM PASS',
            key: 'minNumberOfPassengers',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RETURN',
            key: 'returnCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN TOUR PASS',
            key: 'minNumberOfTourParticipants',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX TOUR PASS',
            key: 'maxNumberOfTourParticipants',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO TOUR COND',
            key: 'numberOfTourConductors',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO PAY PASS',
            key: 'numberOfPayingPassengers',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX TOUR COND',
            key: 'maxNumberOfTourConductors',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AGE',
            key: 'minAgeOfTourConductor',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVL CODE',
            key: 'tvlCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DIFF GRP',
            key: 'diff',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WRT APP',
            key: 'writ',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND995ID',
            key: 'andTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET995ID',
            key: 'betweenTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GEO995ID',
            key: 'geographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GR AND995ID',
            key: 'groupAndTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GR BET995ID',
            key: 'groupBetweenTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GR TO AND995ID',
            key: 'groupTourAndTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GR TO BET995ID',
            key: 'groupTourBetweenTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'IND AND995ID',
            key: 'individualAndTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'IND BET995ID',
            key: 'individualBetweenTable995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCTYP',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC1',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC2',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TSI',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '26',
   },
   {
      categoryName: '27 - Tours',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'TOUR TYPE',
            key: 'tourTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TOUR NO',
            key: 'tourNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CXR CODE',
            key: 'carrierCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO OF NIGHTS',
            key: 'numNights',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AMT 1 APP',
            key: 'minAppl1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AMT 1',
            key: 'minAmount1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADD 1 APP',
            key: 'additionalAppl1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADD 1 AMT',
            key: 'additionalAmount1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 1',
            key: 'currency1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DECIMAL 1',
            key: 'decimals1Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AMT 2 APP',
            key: 'minAppl2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AMT 2',
            key: 'minAmount2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADD 2 APP',
            key: 'additionalAppl2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADD 2 AMT',
            key: 'additionalAmount2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 2',
            key: 'currency2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DECIMAL 2',
            key: 'decimals2Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN PERCENT',
            key: 'minimumPercent',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN TOUR AMT 1',
            key: 'priceMinimum1Amount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TOUR CURR 1',
            key: 'priceCurrency1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TOUR DECIMAL 1',
            key: 'priceDecimals1Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN TOUR AMT 2',
            key: 'priceMinimum2Amount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TOUR CURR 2',
            key: 'priceCurrency2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TOUR DECIMAL 2',
            key: 'priceDecimals2Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TOUR APP CODE',
            key: 'priceApplCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PTC',
            key: 'passengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AGE',
            key: 'minimumAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX AGE',
            key: 'maximumAge',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NON REF',
            key: 'nonRefundableInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAV APP',
            key: 'waiverApplicationCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEATH IND',
            key: 'passengerDeathInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ILL IND',
            key: 'passengerIllInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SCH CH IND',
            key: 'scheduleChangeInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT UG IND',
            key: 'ticketUpgradeInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DOC DEN IND',
            key: 'documentDenialInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'JURY IND',
            key: 'juryDutyInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIL IND',
            key: 'militaryOrdersInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE INC IND',
            key: 'fareIncreaseInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PAY REC IND',
            key: 'paymentReceivedInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO OF SEG',
            key: 'numberOfSegments',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN GR AMT',
            key: 'cat27SegMinimumGroundAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GR CURR',
            key: 'cat27SegCurrencyCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GR DECIMAL',
            key: 'cat27SegDecimalPlaces',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GR APP',
            key: 'cat27SegDayTotalIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN TRANSFER',
            key: 'cat27SegTransferNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CAR REN DAY',
            key: 'cat27SegMinimumCarRentalDays',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESORT DAY',
            key: 'cat27SegMinimumDaysAtResort',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SHIP DAY',
            key: 'cat27SegMinimumDaysOnShip',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OTH GR DAY',
            key: 'cat27SegOtherMinimumDays',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FREE DAYS',
            key: 'cat27SegMaximumConsecutiveFreeDays',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '27',
   },
   {
      categoryName: '28 - Visit Another Country',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'PTC',
            key: 'passengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'IND TAG',
            key: 'identificationTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AGE',
            key: 'minimumAgeOfPassenger',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MAX AGE',
            key: 'maximumAgeOfPassenger',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES CODE',
            key: 'residentCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVL IND',
            key: 'travelIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO OF MILES',
            key: 'numberOfMiles',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT TYPE IND',
            key: 'vacTypeTicketIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCALE GEO',
            key: 'localeGeographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCALE LOCTYP',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCALE LOC1',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCALE LOC2',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCALE TSI',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NON R GEO',
            key: 'nonResidenceGeographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NON R LOCTYP',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NON R LOC1',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NON R LOC2',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NON R TSI',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '28',
   },

   {
      categoryName: '29 - Deposits',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'DEP REQ CODE',
            key: 'depositRequiredCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST MIN AMT',
            key: 'firstMinimumDepositAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST MIN CURR',
            key: 'firstDepositCurrencyCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST MIN DEC',
            key: 'decimalPlacesForFirstCurrency',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEC MIN AMT',
            key: 'secondMinimumDepositAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEC MIN CURR',
            key: 'secondDepositCurrencyCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEC MIN DEC',
            key: 'decimalPlacesForSecondCurrency',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE PER DEP',
            key: 'farePercentToDeposit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEP APP CODE',
            key: 'depositApplCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEP CODE',
            key: 'depositDays',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST DATE',
            key: 'lastDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEAT DEP IND',
            key: 'seatDepositIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NON REF IND',
            key: 'nonRefundableDepositIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST REF AMT',
            key: 'firstRefundableAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST REF CURR',
            key: 'firstRefundCurrencyCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST REF DEC',
            key: 'decimalPlacesForFirstRefundCurrency',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEC REF AMT',
            key: 'secondRefundableAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEC REF CURR',
            key: 'secondRefundCurrencyCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEC REF DEC',
            key: 'decimalPlacesForSecondRefundCurrency',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REF PERCENT',
            key: 'refundPercent',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REF APP CODE',
            key: 'refundApplCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REF DAYS',
            key: 'refundDays',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAV APP CODE',
            key: 'waiversApplCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEATH CODE',
            key: 'deathCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ILL CODE',
            key: 'illnessCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SCH CHANGE',
            key: 'scheduleChange',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT UG',
            key: 'ticketUpgrade',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DENIAL DOCS',
            key: 'denialOfDocuments',
            operator: '',
            values: '',
         },
         {
            keyCode: 'JURY DUTY',
            key: 'juryDuty',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIL ORDER',
            key: 'militaryOrders',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AIRFARE INC',
            key: 'airfareIncrease',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FULL SEATS',
            key: 'fullyPaidForSeats',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEP GEO 995',
            key: 'depositGeographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEP LOCTYP',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEP LOC1',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEP LOC2',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEP TSI',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REF GEO 995',
            key: 'refundGeographic995Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REF LOCTYP',
            key: 'locationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REF LOC1',
            key: 'location1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REF LOC2',
            key: 'location2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REF TSI',
            key: 'travelSegmentIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '29',
   },
   {
      categoryName: '31 - Voluntary Changes',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'PTC',
            key: 'passengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT VAL IND',
            key: 'ticketValidityInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'JRNY CODE',
            key: 'journeyCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PRICE UNIT',
            key: 'pricingUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE CO CODE',
            key: 'fareComponentCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FROM CODE',
            key: 'fromPointCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TO CODE',
            key: 'toPointCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST P',
            key: 'lastPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST U',
            key: 'lastUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CHANGE IND',
            key: 'changeInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST OCC',
            key: 'firstOccurrence',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST OCC',
            key: 'lastOccurrence',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PEN 1 AMT',
            key: 'penalty1Amount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 1',
            key: 'currency1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 1 NO',
            key: 'decimals1Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PEN PERCENT',
            key: 'penaltyPercent',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PEN 2 AMT',
            key: 'penalty2Amount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 2',
            key: 'currency2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 2 NO',
            key: 'decimals2Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'H/L CODE',
            key: 'highLowCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AMT',
            key: 'minimumAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR CODE',
            key: 'currencyCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC',
            key: 'decimalsNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ASSESS CODE',
            key: 'assessmentCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FEE APP CODE',
            key: 'feeApplicationCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT TYPE',
            key: 'ticketTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DIS TYPE',
            key: 'discountTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES TYPE',
            key: 'residualPenaltyCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REF TYPE',
            key: 'refundTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ENDO TYPE',
            key: 'endorsementInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REISSUE 988',
            key: 'reissue988Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAIVER 987',
            key: 'waiver987Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '31',
   },
   {
      categoryName: '33 - Voluntary Refunds',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'PTC',
            key: 'passengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT VAL IND',
            key: 'ticketValidityInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT P',
            key: 'ticketPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT U',
            key: 'ticketUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'JRNY CODE',
            key: 'journeyCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PRICE UNIT',
            key: 'pricingUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE CO CODE',
            key: 'fareComponentCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FROM CODE',
            key: 'fromPointCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST TOD',
            key: 'lastTimeOfDay',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST P',
            key: 'lastPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LAST U',
            key: 'lastUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT LIMIT',
            key: 'ticketTimeLimit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADV RES',
            key: 'advanceReservationsValidation',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FULL FLOWN',
            key: 'fullyFlown',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ORG SCH REF',
            key: 'originallyScheduledRefund',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ORG SCH P',
            key: 'originallyScheduledPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ORG SCH U',
            key: 'originallyScheduledUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CANCEL IND',
            key: 'cancellationIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE POINT',
            key: 'fareBreakPoints',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RE IND',
            key: 'rePriceIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RTN',
            key: 'ruleTariffNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PVT PUB IND',
            key: 'pvtPubTariffIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RULE NUM',
            key: 'ruleNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIELD IND',
            key: 'fieldIndicator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FCC',
            key: 'fareClassCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SAME CODE',
            key: 'sameCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE CODE',
            key: 'normalSpecialFareCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OW/RT',
            key: 'owRtIndString',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE AMT',
            key: 'fareAmountCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BOOK CODE',
            key: 'bookingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PEN 1 AMT',
            key: 'penaltyAmount1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 1',
            key: 'currencyCode1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 1 NO',
            key: 'decimalPlace1',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BASE PERCENT',
            key: 'baseFarePercentage',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PEN 2 AMT',
            key: 'penaltyAmount2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 2',
            key: 'currencyCode2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 2 NO',
            key: 'decimalPlace2',
            operator: '',
            values: '',
         },
         {
            keyCode: 'H/L AMT',
            key: 'higherLowerAmountCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'MIN AMT',
            key: 'minimumAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 3',
            key: 'currencyCode3',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DEC 3 NO',
            key: 'decimalPlace3',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PU/FC',
            key: 'puFCCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CALC OP',
            key: 'calculationOption',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DIS TAG',
            key: 'discountTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REFUND',
            key: 'formOfRefund',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NON REF CODE',
            key: 'taxNonRefundCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CUST P',
            key: 'custFirstPeriod',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CUST U',
            key: 'custFirstUnit',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RES TKT CODE',
            key: 'reservationTicketingCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CXR 990',
            key: 'carrier990Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE TYPE 974',
            key: 'fareTypeTable974Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'WAV 987',
            key: 'waiver987Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '33',
   },
   {
      categoryName: '35 - Negotiated Fare',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'SEC 983 ID',
            key: 'security983Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PTC',
            key: 'passengerTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE 979 ID',
            key: 'fareCreator979Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'METHOD TYPE',
            key: 'methodTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NET/GROSS',
            key: 'netGrossInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'COMM PERCENT',
            key: 'commissionPercent',
            operator: '',
            values: '',
         },
         {
            keyCode: 'COMM 1 AMT',
            key: 'commission1Amount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 1',
            key: 'currency1Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DECIMAL 1',
            key: 'decimals1Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'COMM 2 AMT',
            key: 'commission2Amount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CURR 2',
            key: 'currency2Code',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DECIMAL 2',
            key: 'decimals2Number',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UG IND',
            key: 'upgradeInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BAG NO',
            key: 'baggageNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BAG NO APP',
            key: 'pieceKilogramInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT IND',
            key: 'ticketingInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NOT PERM IND',
            key: 'notPermittedInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT CXR CODE',
            key: 'ticketCarrierCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO OF SEGS',
            key: 'numberOfSegment',
            operator: '',
            values: '',
         },
         {
            keyCode: 'COUPON CODE',
            key: 'cat35SegCouponCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TOUR CODE',
            key: 'cat35SegType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TOUR BOX',
            key: 'cat35SegTourBoxCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT DESG',
            key: 'cat35SegTicketDesignator',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TKT FARE DATA',
            key: 'cat35SegTicketFareData',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OWRT IND',
            key: 'cat35SegOwrtInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GLOBAL IND',
            key: 'cat35SegGlobalInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RTN',
            key: 'cat35SegRuleTariffNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CXR CODE',
            key: 'cat35SegCarrierCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RULE NO',
            key: 'cat35SegRuleNumber',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FCC',
            key: 'cat35SegFareClassCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FTC',
            key: 'cat35SegFareTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'STC',
            key: 'cat35SegSeasonTypeCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DOW TC',
            key: 'cat35SegDayOfWeekType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BET CITY CODE',
            key: 'cat35SegBetweenCityCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'AND CITY CODE',
            key: 'cat35SegAndCityCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE BOX TXT',
            key: 'cat35SegFareBox',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE BOX AMT',
            key: 'cat35SegAmount',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE BOX CURR',
            key: 'cat35SegCurrencyCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FARE BOX DEC',
            key: 'cat35SegDecimalPlace',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '35',
   },
   {
      categoryName: '50 - Rule Application',
      screen: ['Rules'],
      type: 'DropDownText',
      categoryDetails: [
         {
            keyCode: 'APP TITLE',
            key: 'applicationTitle',
            operator: '',
            values: '',
         },
         {
            keyCode: 'FIRST CLASS',
            key: 'firstClassInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'BUS CLASS',
            key: 'businessClassInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ECO CLASS',
            key: 'economyClassInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'COACH CLASS',
            key: 'coachClassInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OFF CO CLASS',
            key: 'offPeakCoachClassInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SUPER IND',
            key: 'supersonicInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OW RULE IND',
            key: 'oneWayRuleInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RT RULE IND',
            key: 'roundTripRuleInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OW IND',
            key: 'oneWayInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RT IND',
            key: 'roundTripInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CT IND',
            key: 'circleTripInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OJ IND',
            key: 'openJawInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SOJ IND',
            key: 'singleOpenJawInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ORIGIN SOJ IND',
            key: 'originSojInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TA SOJ IND',
            key: 'turnAroundSojInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'DOJ IND',
            key: 'doubleOpenJawInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RTW IND',
            key: 'roundTheWorldInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'JT IND',
            key: 'jointTransportInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'INC TOUR',
            key: 'inclusiveToursCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'GROUP CODE',
            key: 'groupsCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'PUR CODE',
            key: 'purchaseCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'INTER POINTS',
            key: 'intermediatePointsInd',
            operator: '',
            values: '',
         },
         {
            keyCode: 'D/I CODE',
            key: 'domIntCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'SEG NO',
            key: 'noOfSegments',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOCALE CODE',
            key: 'cat50SegGeoLocalCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC CODE',
            key: 'cat50SegLocationCode',
            operator: '',
            values: '',
         },
         {
            keyCode: 'LOC TYPE',
            key: 'cat50SegLocationType',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADD FARE TEXT ID',
            key: 'addlFareText996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'ADD FARE TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CAPA TEXT ID',
            key: 'capacityText996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'CAPA TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO APP ID',
            key: 'notApplText996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'NO APP TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OTHER TEXT ID',
            key: 'otherText996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OTHER TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'OVRD 994',
            key: 'dateOverride994Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLEFF 994',
            key: 'travelEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TVLDIS 994',
            key: 'travelDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESEFF 994',
            key: 'reservationEffectiveDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'RESDISC 994',
            key: 'reservationDiscontinueDate',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT 996',
            key: 'text996Id',
            operator: '',
            values: '',
         },
         {
            keyCode: 'TEXT',
            key: 'lineText',
            operator: '',
            values: '',
         },
         {
            keyCode: 'UVD',
            key: 'unavailableTag',
            operator: '',
            values: '',
         },
         {
            keyCode: 'REC DT',
            key: 'transmissionDateTime',
            operator: '',
            values: '',
         },
      ],
      categoryCode: '50',
   },
];
export const DEFAULT_DG_LOG_HEADER = [
   {
      timestamp: '',
      'cr user': '',
      action: '',
      notes: '',
   },
];
export const USER_ACCOUNT_CODE = ['X', 'N', 'C', 'U'];

export const STATUS_CODE = ['W', 'D', 'V'];

export const INSERT_FIELD_MAX_VALUES = [
   {
      key: 'org',
      max: 3,
   },
   {
      key: 'des',
      max: 3,
   },
   {
      key: 'cxr',
      max: 2,
   },
   {
      key: 'fbc',
      max: 8,
   },
   {
      key: 'tar',
      max: 3,
   },
   {
      key: 'owrt',
      max: 1,
   },
   {
      key: 'cur',
      max: 3,
   },
   {
      key: 'rtg',
      max: 4,
   },
   {
      key: 'ft',
      max: 2,
   },
   {
      key: 'amt',
      max: 11,
   },
   {
      key: 'ow amt',
      max: 7,
   },
   {
      key: 'rt amt',
      max: 7,
   },
   {
      key: 'ttl',
      max: 11,
   },
   {
      key: 'eff dt',
      max: 7,
   },
   {
      key: 'disc dt',
      max: 7,
   },
   {
      key: 'uac',
      max: 1,
   },
   {
      key: 'cr user',
      max: 6,
   },
   {
      key: 'fare',
      max: 6,
   },
   {
      key: 'last update',
      max: 100,
   },
   {
      key: 'dist dt',
      max: 100,
   },
   {
      key: 'description',
      max: 100,
   },
   {
      key: 'int dist dt',
      max: 13,
   },
   {
      key: 'ex ind',
      max: 1,
   },
   {
      key: 'rel ind',
      max: 1,
   },
   {
      key: 'rign err',
      max: 1,
   },
   {
      key: 'lfc',
      max: 1,
   },
   {
      key: 'tax ind',
      max: 1,
   },
   {
      key: 'justification',
      max: 100,
   },
   {
      key: 'stauts',
      max: 1,
   },
   {
      key: 'email',
      max: 30,
   },
   {
      key: 'org gwt city',
      max: 3,
   },
   {
      key: 'org fcc',
      max: 8,
   },
   {
      key: 'org ft',
      max: 3,
   },
   {
      key: 'org tar',
      max: 3,
   },
   {
      key: 'org amt',
      max: 100,
   },
   {
      key: 'org cur',
      max: 3,
   },
   {
      key: 'des gwt city',
      max: 3,
   },
   {
      key: 'des fcc',
      max: 8,
   },
   {
      key: 'des ft',
      max: 3,
   },
   {
      key: 'des tar',
      max: 3,
   },
   {
      key: 'des amt',
      max: 100,
   },
   {
      key: 'des cur',
      max: 3,
   },
   {
      key: 'spec org',
      max: 2,
   },
   {
      key: 'spec dest',
      max: 3,
   },
   {
      key: 'spec amt',
      max: 200,
   },
   {
      key: 'spec curr',
      max: 3,
   },
];

export const SEARCH_CRITERIA_FOOTER_CONFIG = [
   {
      key: 'Button',
      value: 'CLEAR',
      isSelect: false,
   },
   {
      key: 'Button',
      value: 'STOP',
      isSelect: false,
   },
   {
      key: 'Button',
      value: 'SEARCH',
      isSelect: false,
   },
];
export const CONTEXT_MENU_OPTIONS_FARES = [
   {
      key: 'Insert',
      shortCut: 'Ctrl + I',
   },
   {
      key: 'Template',
      shortCut: '',
   },
   {
      key: 'Cancel',
      shortCut: 'Ctrl + X',
   },
   {
      key: 'Undo',
      shortCut: 'Ctrl + Z',
   },
   {
      key: 'Delete',
      shortCut: 'Ctrl + D',
   },
   {
      key: 'Save',
      shortCut: 'Ctrl + S',
   },
];
export const CONTEXT_MENU_OPTIONS_DISTRIBUTION = [
   {
      key: 'New Distribution Group',
      shortCut: 'Ctrl + G',
   },
   {
      key: 'Delete',
      shortCut: 'Ctrl + D',
   },
   {
      key: 'Copy',
      shortCut: 'Ctrl + C',
   },
   {
      key: 'Remove Selected',
      shortCut: 'Ctrl + Q',
   },
   {
      key: 'Undo Selected',
      shortCut: 'Ctrl + Z',
   },
   {
      key: 'Save',
      shortCut: 'Ctrl + S',
   },
   {
      key: 'Show Fares',
      shortCut: 'Ctrl + R',
   },
   {
      key: 'Distribute/Approve',
      shortCut: 'Ctrl + B',
   },
];
export const DISTRIBUTION_GROUP = 'Distribution Group';
export const PRIMARY_TABLE = [
   {
      org: 'BBB',
      des: 'CCC',
      cxr: 'ZZ',
      fbc: 'LL106LGT',
      tar: 1,
      ft: '3O',
      rtg: '401',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'YY',
      fbc: 'LK106LGT',
      tar: 1,
      ft: '3V',
      rtg: '402',
   },
   {
      org: 'BBB',
      des: 'CCC',
      cxr: 'ZZ',
      fbc: 'TL287LGT',
      tar: 1,
      ft: '3O',
      rtg: '3195',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'YY',
      fbc: 'TLA46LGT',
      tar: 1,
      ft: 'AJ',
      rtg: '0',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'YY',
      fbc: 'TKA46LGT',
      tar: 1,
      ft: '5H',
      rtg: '432',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'YY',
      fbc: 'KLX87NCT',
      tar: 1,
      ft: '8Z',
      rtg: '401',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'KKX87NCT',
      tar: 1,
      ft: '3O',
      rtg: '402',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'KL181NCV',
      tar: 1,
      ft: '9K',
      rtg: '3195',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'ZZ',
      fbc: 'TLW46LGT',
      tar: 1,
      ft: 'GW',
      rtg: '0',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'YY',
      fbc: 'TKX77LGT',
      tar: 1,
      ft: '',
      rtg: '432',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'YY',
      fbc: 'TKW46LGT',
      tar: 1,
      ft: '9K',
      rtg: '401',
   },
   {
      org: 'BBB',
      des: 'CCC',
      cxr: 'YY',
      fbc: 'TLX77LGT',
      tar: 1,
      ft: '7A',
      rtg: '402',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'YY',
      fbc: 'TL181LGT',
      tar: 1,
      ft: '7A',
      rtg: '3195',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'KL106NCV',
      tar: 1,
      ft: '9K',
      rtg: '0',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'TL106LGT',
      tar: 1,
      ft: '7A',
      rtg: '432',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'SL287LGT',
      tar: 1,
      ft: '7A',
      rtg: '401',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'YY',
      fbc: 'TKX87LGT',
      tar: 1,
      ft: '7A',
      rtg: '402',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'TLX07LGT',
      tar: 1,
      ft: '7A',
      rtg: '3195',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'TKX07LGT',
      tar: 1,
      ft: '3O',
      rtg: '0',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'TK181LGT',
      tar: 1,
      ft: '7A',
      rtg: '432',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'YY',
      fbc: 'TK246LGT',
      tar: 1,
      ft: '3O',
      rtg: '401',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'ZZ',
      fbc: 'SL387LGT',
      tar: 1,
      ft: '3O',
      rtg: '600',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'ZZ',
      fbc: 'SK297LGT',
      tar: 1,
      ft: '3O',
      rtg: '3195',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'YY',
      fbc: 'SKX87LGT',
      tar: 1,
      ft: '5H',
      rtg: '0',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'YY',
      fbc: 'LKW87NCT',
      tar: 1,
      ft: '4G',
      rtg: '432',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'YY',
      fbc: 'LKX46NCT',
      tar: 1,
      ft: '5H',
      rtg: '401',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'YY',
      fbc: 'LLW87NCT',
      tar: 1,
      ft: '5H',
      rtg: '402',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'ZZ',
      fbc: 'LLX46NCT',
      tar: 1,
      ft: '8Z',
      rtg: '3195',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'TLW77LGT',
      tar: 1,
      ft: '5H',
      rtg: '0',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'TKW77LGT',
      tar: 1,
      ft: '5H',
      rtg: '432',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'YY',
      fbc: 'LL106NCV',
      tar: 1,
      ft: '3N',
      rtg: '401',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'WL387LGT',
      tar: 1,
      ft: '3N',
      rtg: '402',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'YY',
      fbc: 'WK257LGT',
      tar: 1,
      ft: '9K',
      rtg: '3195',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'WL226LGT',
      tar: 1,
      ft: '3N',
      rtg: '0',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'TKW87LGT',
      tar: 1,
      ft: '7A',
      rtg: '432',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'WKX87LGT',
      tar: 1,
      ft: '5H',
      rtg: '401',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'SK106LGT',
      tar: 1,
      ft: '5H',
      rtg: '402',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'LK106NCV',
      tar: 1,
      ft: '3V',
      rtg: '3195',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'SL226LGT',
      tar: 1,
      ft: 'LL',
      rtg: '0',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'YY',
      fbc: 'TL287NCV',
      tar: 1,
      ft: 'DK',
      rtg: '432',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'TKA46NCT',
      tar: 1,
      ft: '5H',
      rtg: '401',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'TLA46NCT',
      tar: 1,
      ft: '3O',
      rtg: '402',
   },
   {
      org: 'AAA',
      des: 'DDD',
      cxr: 'ZZ',
      fbc: 'SKW07LGT',
      tar: 1,
      ft: '3N',
      rtg: '3195',
   },
   {
      org: 'BBB',
      des: 'CCC',
      cxr: 'YY',
      fbc: 'SLW07LGT',
      tar: 1,
      ft: '3N',
      rtg: '0',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'ZZ',
      fbc: 'SL186LGT',
      tar: 1,
      ft: '3N',
      rtg: '432',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'YY',
      fbc: 'WK287LGT',
      tar: 1,
      ft: '8Z',
      rtg: '401',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'YY',
      fbc: 'WK397LGT',
      tar: 1,
      ft: '3N',
      rtg: '402',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'ZZ',
      fbc: 'WKW87LGT',
      tar: 1,
      ft: '3N',
      rtg: '3195',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'YY',
      fbc: 'WL247LGT',
      tar: 1,
      ft: '9K',
      rtg: '0',
   },
   {
      org: 'AAA',
      des: 'CCC',
      cxr: 'ZZ',
      fbc: 'WKA46LGT',
      tar: 1,
      ft: '9K',
      rtg: '432',
   },
];
export const SECONDARY_FULL_TABLE = [
   {
      categoryTitle: 'fareValue',
      data: [
         {
            owrt: 2,
            cur: 'USD',
            amt: 215,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 98.57,
            ttl: 713.57,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 233,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 98.57,
            ttl: 731.57,
            cab: 'Y',
            rbd: 'Q',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 200,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 98.57,
            ttl: 738.69,
            cab: 'Y',
            rbd: 'K',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 201,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 98.57,
            ttl: 739.69,
            cab: 'Y',
            rbd: 'K',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 201,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 98.57,
            ttl: 740.57,
            cab: 'Y',
            rbd: 'K',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 242,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 98.57,
            ttl: 749.57,
            cab: 'Y',
            rbd: 'K',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 242,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 98.57,
            ttl: 770.57,
            cab: 'Y',
            rbd: 'S',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 251,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 138.69,
            ttl: 770.57,
            cab: 'Y',
            rbd: 'S',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 272,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 138.69,
            ttl: 770.57,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 272,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 138.69,
            ttl: 779.57,
            cab: 'Y',
            rbd: 'W',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 281,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 138.69,
            ttl: 783.57,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 285,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 138.69,
            ttl: 783.57,
            cab: 'Y',
            rbd: 'Q',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 250,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 138.69,
            ttl: 788.69,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 300,
            sur: 0,
            yq: 600,
            yr: 100,
            tax: 138.69,
            ttl: 798.57,
            cab: 'Y',
            rbd: 'T',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 300,
            sur: 0,
            yq: 600,
            yr: 100,
            tax: 138.69,
            ttl: 820.57,
            cab: 'Y',
            rbd: 'S',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 342,
            sur: 600,
            yq: 600,
            yr: 100,
            tax: 352.47,
            ttl: 820.57,
            cab: 'Y',
            rbd: 'S',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 398,
            sur: 600,
            yq: 600,
            yr: 100,
            tax: 138.69,
            ttl: 820.57,
            cab: 'Y',
            rbd: 'O',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 398,
            sur: 600,
            yq: 600,
            yr: 100,
            tax: 352.47,
            ttl: 829.57,
            cab: 'Y',
            rbd: 'S',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 372,
            sur: 600,
            yq: 600,
            yr: 100,
            tax: 138.69,
            ttl: 834.57,
            cab: 'Y',
            rbd: 'W',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 385,
            sur: 600,
            yq: 300,
            yr: 100,
            tax: 138.69,
            ttl: 838.69,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 350,
            sur: 600,
            yq: 300,
            yr: 100,
            tax: 138.69,
            ttl: 840.57,
            cab: 'Y',
            rbd: 'W',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 350,
            sur: 600,
            yq: 300,
            yr: 100,
            tax: 138.69,
            ttl: 840.57,
            cab: 'Y',
            rbd: 'W',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 400,
            sur: 600,
            yq: 300,
            yr: 100,
            tax: 352.47,
            ttl: 870.57,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 350,
            sur: 600,
            yq: 300,
            yr: 100,
            tax: 98.57,
            ttl: 745.51,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 403,
            sur: 600,
            yq: 300,
            yr: 100,
            tax: 98.57,
            ttl: 745.51,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 410,
            sur: 600,
            yq: 300,
            yr: 100,
            tax: 98.57,
            ttl: 883.57,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 370,
            sur: 600,
            yq: 300,
            yr: 100,
            tax: 98.57,
            ttl: 888.69,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 371,
            sur: 600,
            yq: 300,
            yr: 100,
            tax: 98.57,
            ttl: 888.69,
            cab: 'Y',
            rbd: 'W',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 422,
            sur: 600,
            yq: 300,
            yr: 100,
            tax: 98.57,
            ttl: 898.57,
            cab: 'Y',
            rbd: 'W',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 428,
            sur: 600,
            yq: 300,
            yr: 100,
            tax: 98.57,
            ttl: 898.57,
            cab: 'Y',
            rbd: 'W',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 281,
            sur: 600,
            yq: 600,
            yr: 100,
            tax: 98.57,
            ttl: 901.57,
            cab: 'Y',
            rbd: 'T',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 285,
            sur: 640,
            yq: 600,
            yr: 100,
            tax: 98.57,
            ttl: 908.57,
            cab: 'Y',
            rbd: 'T',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 300,
            sur: 640,
            yq: 600,
            yr: 100,
            tax: 98.57,
            ttl: 908.69,
            cab: 'Y',
            rbd: 'T',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 450,
            sur: 640,
            yq: 600,
            yr: 100,
            tax: 98.57,
            ttl: 920.57,
            cab: 'Y',
            rbd: 'T',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 402,
            sur: 640,
            yq: 600,
            yr: 100,
            tax: 98.57,
            ttl: 926.57,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 402,
            sur: 640,
            yq: 600,
            yr: 100,
            tax: 98.57,
            ttl: 938.69,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 402,
            sur: 640,
            yq: 600,
            yr: 100,
            tax: 98.57,
            ttl: 940.57,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 395,
            sur: 640,
            yq: 600,
            yr: 100,
            tax: 98.57,
            ttl: 1002.47,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 395,
            sur: 640,
            yq: 600,
            yr: 100,
            tax: 98.57,
            ttl: 800.29,
            cab: 'Y',
            rbd: 'L',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 395,
            sur: 640,
            yq: 600,
            yr: 100,
            tax: 138.69,
            ttl: 1052.47,
            cab: 'Y',
            rbd: 'T',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 298,
            sur: 640,
            yq: 600,
            yr: 100,
            tax: 138.69,
            ttl: 1170.57,
            cab: 'Y',
            rbd: 'T',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 322,
            sur: 640,
            yq: 600,
            yr: 100,
            tax: 138.69,
            ttl: 800.29,
            cab: 'Y',
            rbd: 'T',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 336,
            sur: 640,
            yq: 600,
            yr: 100,
            tax: 138.69,
            ttl: 800.29,
            cab: 'Y',
            rbd: 'T',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 331,
            sur: 640,
            yq: 600,
            yr: 100,
            tax: 138.69,
            ttl: 800.29,
            cab: 'Y',
            rbd: 'T',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 272,
            sur: 640,
            yq: 600,
            yr: 100,
            tax: 138.69,
            ttl: 800.29,
            cab: 'Y',
            rbd: 'T',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 350,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 138.67,
            ttl: 800.29,
            cab: 'Y',
            rbd: 'T',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 350,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 138.67,
            ttl: 800.29,
            cab: 'Y',
            rbd: 'K',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 360,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 138.67,
            ttl: 1320.57,
            cab: 'Y',
            rbd: 'K',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 215,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 138.67,
            ttl: 1389.57,
            cab: 'Y',
            rbd: 'K',
         },
         {
            owrt: 2,
            cur: 'USD',
            amt: 250,
            sur: 0,
            yq: 300,
            yr: 100,
            tax: 138.67,
            ttl: 1380.57,
            cab: 'Y',
            rbd: 'K',
         },
      ],
   },
   {
      categoryTitle: 'footnote',
      data: [
         {
            'fst res': 'sfsdf',
            'lst res': 'xczzxc',
            'fst tkt': 'zxc',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '30JAN23',
            'tvl end': '',
            'tvl cmplt': '28JAN24',
            'tvl dt': '30JAN23--28JAN24/10MAR24--23MAY24',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '30JAN23',
            'tvl end': '',
            'tvl cmplt': '28JAN24',
            'tvl dt': '30JAN23--28JAN24/10MAR24--23MAY24',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '20JAN21',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '20JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '20JAN21',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '20JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '30JAN23',
            'tvl end': '',
            'tvl cmplt': '28JAN24',
            'tvl dt': '30JAN23--28JAN24/10MAR24--23MAY24',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '20JAN21',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '20JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '20JAN21',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '20JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '20JAN21',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '20JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '04JAN23',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '31JAN24',
            'tvl dt': '--31JAN23',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '04JAN23',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '31JAN24',
            'tvl dt': '--31JAN23',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '04JAN23',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '31JAN24',
            'tvl dt': '--31JAN23',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '30JAN23',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '20JAN21',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '20JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '20JAN21',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '20JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '20JAN21',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '20JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '20JAN21',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '20JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '04JAN23',
            'tvl st': '31JAN23',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '--31JAN23',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '28JAN23',
            'tvl end': '',
            'tvl cmplt': '31JAN23',
            'tvl dt': '28JAN23--10JAN23',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '20JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '20JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '20JAN21',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '20JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '29JAN20--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '29JAN20--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '30JUN24',
            'tvl end': '',
            'tvl cmplt': '28JUN24',
            'tvl dt': '30JUN24--28JUN24/10AUG24--23AUG24',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '04JAN23',
            'tvl st': '31JAN23',
            'tvl end': '',
            'tvl cmplt': '31JAN23',
            'tvl dt': '--31JAN23',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '04JAN23',
            'tvl st': '31JAN23',
            'tvl end': '',
            'tvl cmplt': '31JAN23',
            'tvl dt': '--31JAN23',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '04JAN23',
            'tvl st': '31JAN23',
            'tvl end': '',
            'tvl cmplt': '31JAN23',
            'tvl dt': '--31JAN23',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '30APR24',
            'tvl end': '',
            'tvl cmplt': '28APR24',
            'tvl dt': '30APR24--28APR24/10AUG24--23AUG24',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '30APR24',
            'tvl end': '',
            'tvl cmplt': '28APR24',
            'tvl dt': '30APR24--28APR24/10AUG24--23AUG24',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '28JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '28JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '',
            'tvl end': '',
            'tvl cmplt': '',
            'tvl dt': '28JAN21--',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '30APR24',
            'tvl end': '',
            'tvl cmplt': '28APR24',
            'tvl dt': '30APR24--28APR24/10AUG24--23AUG24',
         },
         {
            'fst res': '',
            'lst res': '',
            'fst tkt': '',
            'lst tkt': '',
            'tvl st': '30APR24',
            'tvl end': '',
            'tvl cmplt': '28APR24',
            'tvl dt': '30APR24--28APR24/10AUG24--23AUG24',
         },
      ],
   },
   {
      categoryTitle: 'rule',
      data: [
         {
            rule: 'E602',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 3,
            'min st num': '',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E602',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 9,
            'min st num': '',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E602',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 9,
            'min st num': '',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E602',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 9,
            'min st num': '',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E602',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 9,
            'min st num': '',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E602',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 9,
            'min st num': '',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E602',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 9,
            'min st num': '',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E602',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 22,
            'min st num': '',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E602',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 22,
            'min st num': '',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E602',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 22,
            'min st num': '',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E700',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 54,
            'min st num': '7',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E700',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 54,
            'min st num': '7',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E700',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 54,
            'min st num': '7',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E700',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 54,
            'min st num': '7',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E700',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 54,
            'min st num': '7',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E700',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 90,
            'min st num': '7',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E700',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 90,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E700',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 90,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E700',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 90,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E700',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 3,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E700',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 3,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E700',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 3,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J513',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 3,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J513',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 81,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J513',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 81,
            'min st num': '10',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J513',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 81,
            'min st num': '10',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J513',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 81,
            'min st num': '10',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J513',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 81,
            'min st num': '',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J513',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 76,
            'min st num': '',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J513',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 76,
            'min st num': '',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J513',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 76,
            'min st num': '',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J513',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 98,
            'min st num': '',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J505',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 98,
            'min st num': '',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J505',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 98,
            'min st num': '',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J505',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 5,
            'min st num': '',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J505',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 5,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J505',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 5,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J505',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 5,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J505',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 43,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J505',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 43,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J505',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 43,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J505',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 4,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'J505',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 4,
            'min st num': '10',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E602',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 4,
            'min st num': '7',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E602',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 4,
            'min st num': '7',
            'min st dow': '',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E602',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 67,
            'min st num': '7',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E602',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 67,
            'min st num': '7',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E602',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 67,
            'min st num': '7',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E700',
            'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24',
            ap: 67,
            'min st num': '7',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
         {
            rule: 'E700',
            'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24',
            ap: 67,
            'min st num': '7',
            'min st dow': 'SAT',
            'max st': '6',
            'bo dt': '',
         },
      ],
   },
   {
      categoryTitle: 'market',
      data: [
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GB', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GB', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GB', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GB', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GB', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GB', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
         { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
         { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
      ],
   },
   {
      categoryTitle: 'brand',
      data: [
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'FLEX', 'brd det': 'NO BAG' },
         { brd: 'FLEX', 'brd det': 'NO BAG' },
         { brd: 'FLEX', 'brd det': 'NO BAG' },
         { brd: 'FLEX', 'brd det': 'NO BAG' },
         { brd: 'FLEX', 'brd det': 'NO BAG' },
         { brd: 'FLEX', 'brd det': 'FREE BAG' },
         { brd: 'FLEX', 'brd det': 'FREE BAG' },
         { brd: 'FLEX', 'brd det': 'FREE BAG' },
         { brd: 'FLEX', 'brd det': 'FREE BAG' },
         { brd: 'FLEX', 'brd det': 'FREE BAG' },
         { brd: 'FLEX', 'brd det': 'FREE BAG' },
         { brd: 'FLEX', 'brd det': 'FREE BAG' },
         { brd: 'FLEX', 'brd det': 'FREE BAG' },
         { brd: 'FLEX', 'brd det': 'FREE BAG' },
         { brd: 'LIGHT', 'brd det': 'FREE BAG' },
         { brd: 'LIGHT', 'brd det': 'FREE BAG' },
         { brd: 'LIGHT', 'brd det': 'FREE BAG' },
         { brd: 'LIGHT', 'brd det': 'FREE BAG' },
         { brd: 'LIGHT', 'brd det': 'FREE BAG' },
         { brd: 'LIGHT', 'brd det': 'FREE BAG' },
         { brd: 'LIGHT', 'brd det': 'FREE BAG' },
         { brd: 'LIGHT', 'brd det': 'FREE BAG' },
         { brd: 'LIGHT', 'brd det': 'FREE BAG' },
         { brd: 'LIGHT', 'brd det': 'FREE BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'LIGHT', 'brd det': 'NO BAG' },
         { brd: 'FLEX', 'brd det': 'NO BAG' },
         { brd: 'FLEX', 'brd det': 'NO BAG' },
         { brd: 'FLEX', 'brd det': 'NO BAG' },
         { brd: 'FLEX', 'brd det': 'NO BAG' },
         { brd: 'FLEX', 'brd det': 'NO BAG' },
         { brd: 'FLEX', 'brd det': 'NO BAG' },
         { brd: 'FLEX', 'brd det': 'NO BAG' },
         { brd: 'FLEX', 'brd det': 'NO BAG' },
      ],
   },
   {
      categoryTitle: 'distribution',
      data: [
         { 'eff dt': '29JAN21', 'disc dt': '', 'rec dt': '28JAN21 1000' },
         { 'eff dt': '12JAN23', 'disc dt': '', 'rec dt': '11JAN23 1000' },
         { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
         { 'eff dt': '25JAN23', 'disc dt': '', 'rec dt': '24JAN23 1000' },
         { 'eff dt': '25JAN23', 'disc dt': '', 'rec dt': '24JAN23 1000' },
         { 'eff dt': '14JAN23', 'disc dt': '', 'rec dt': '13JAN23 1000' },
         { 'eff dt': '11JAN23', 'disc dt': '', 'rec dt': '10JAN23 1000' },
         { 'eff dt': '14JAN23', 'disc dt': '', 'rec dt': '13JAN23 1000' },
         { 'eff dt': '29JAN21', 'disc dt': '', 'rec dt': '28JAN21 1000' },
         { 'eff dt': '11JAN23', 'disc dt': '', 'rec dt': '10JAN23 1000' },
         { 'eff dt': '07JAN22', 'disc dt': '', 'rec dt': '06JAN22 1000' },
         { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
         { 'eff dt': '20JAN23', 'disc dt': '', 'rec dt': '19JAN23 1000' },
         { 'eff dt': '14JAN23', 'disc dt': '', 'rec dt': '13JAN23 1000' },
         { 'eff dt': '12JAN23', 'disc dt': '', 'rec dt': '11JAN23 1000' },
         { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
         { 'eff dt': '12JAN23', 'disc dt': '', 'rec dt': '11JAN23 1000' },
         { 'eff dt': '20JAN23', 'disc dt': '', 'rec dt': '19JAN23 1000' },
         { 'eff dt': '14JAN23', 'disc dt': '', 'rec dt': '13JAN23 1000' },
         { 'eff dt': '11JAN23', 'disc dt': '', 'rec dt': '10JAN23 1000' },
         { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
         { 'eff dt': '12JAN23', 'disc dt': '', 'rec dt': '11JAN23 1000' },
         { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
         { 'eff dt': '20JAN23', 'disc dt': '', 'rec dt': '19JAN23 1000' },
         { 'eff dt': '12JAN23', 'disc dt': '', 'rec dt': '11JAN23 1000' },
         { 'eff dt': '18JAN23', 'disc dt': '', 'rec dt': '17JAN23 1000' },
         { 'eff dt': '11JAN23', 'disc dt': '', 'rec dt': '10JAN23 1000' },
         { 'eff dt': '06JAN21', 'disc dt': '', 'rec dt': '05JAN21 1000' },
         { 'eff dt': '11JAN23', 'disc dt': '', 'rec dt': '10JAN23 1000' },
         { 'eff dt': '25JAN23', 'disc dt': '', 'rec dt': '24JAN23 1000' },
         { 'eff dt': '25JAN23', 'disc dt': '', 'rec dt': '24JAN23 1000' },
         { 'eff dt': '14JAN23', 'disc dt': '', 'rec dt': '13JAN23 1000' },
         { 'eff dt': '14JAN23', 'disc dt': '', 'rec dt': '13JAN23 1000' },
         { 'eff dt': '29JAN21', 'disc dt': '', 'rec dt': '28JAN21 1000' },
         { 'eff dt': '12JAN23', 'disc dt': '', 'rec dt': '11JAN23 1000' },
         { 'eff dt': '20JAN23', 'disc dt': '', 'rec dt': '19JAN23 1000' },
         { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
         { 'eff dt': '25JAN23', 'disc dt': '', 'rec dt': '24JAN23 1000' },
         { 'eff dt': '14JAN23', 'disc dt': '', 'rec dt': '13JAN23 1000' },
         { 'eff dt': '29JAN21', 'disc dt': '', 'rec dt': '28JAN21 1000' },
         { 'eff dt': '11JAN23', 'disc dt': '', 'rec dt': '10JAN23 1000' },
         { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
         { 'eff dt': '20JAN23', 'disc dt': '', 'rec dt': '19JAN23 1000' },
         { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
         { 'eff dt': '06JAN23', 'disc dt': '', 'rec dt': '05JAN23 1000' },
         { 'eff dt': '22JAN23', 'disc dt': '', 'rec dt': '21JAN23 1000' },
         { 'eff dt': '22JAN23', 'disc dt': '', 'rec dt': '21JAN23 1000' },
         { 'eff dt': '11JAN23', 'disc dt': '', 'rec dt': '10JAN23 1000' },
         { 'eff dt': '20JAN23', 'disc dt': '', 'rec dt': '19JAN23 1000' },
         { 'eff dt': '13JAN23', 'disc dt': '', 'rec dt': '12JAN23 1000' },
      ],
   },
];
export const MessageRole = {
   ALERT: 'alert',
   REGION: 'region',
   STATUS: 'status',
};
export const MessageStatus = {
   SUCCESS: 'success',
   WARNING: 'warning',
   ERROR: 'error',
   INFO: 'info',
};
export const MessageType = {
   PAGE: 'page',
   CONTAINER: 'container',
};
export const monthNames = [
   'JAN',
   'FEB',
   'MAR',
   'APR',
   'MAY',
   'JUN',
   'JUL',
   'AUG',
   'SEP',
   'OCT',
   'NOV',
   'DEC',
];
export const DATE_TIME_FIELD_KEY = [
   'createdAt',
   'lastUpdatedAt',
   'distributedAt',
   'intDistributionTimeStamp',
];

export const MATH_OPERATIONS = ['+', '-', '*', '/'];
export const FOOTNOTES_CATEGORIES = ['14', '15', '03', '11'];
export const RULES_CATEGORIES = [
   '01',
   '02',
   '03',
   '04',
   '05',
   '06',
   '07',
   '08',
   '09',
   '11',
   '12',
   '13',
   '14',
   '15',
   '16',
   '17',
   '18',
   '19',
   '20',
   '21',
   '22',
   '23',
   '26',
   '27',
   '28',
   '29',
   '31',
   '33',
   '35',
   '50',
];
export const FIELDS_TO_EXCLUDE_FROM_DATE_PICKER = [
   'FT TVL DT',
   'FT SEAS DT',
   'FT BO DT',
   'GFS',
   'REC DT',
   'DG',
   'STATUS',
   'RES DATE',
   'TKT DATE',
];

export const FIELDS_WITH_ONE_CHARACTER_LIMIT = [
   'CON',
   'VCC',
   'OWRT',
   'CAB',
   'RBD',
   'DOW TC',
   'SEAS TC',
   'EX IND',
   'REL IND',
   'IGN ERR',
   'LFC',
   'TAX IND',
   'D/I',
   'REL',
   'IO',
   'DIR',
   'RI',
   'LOCTYP 995',
   'UVD',
   'OVR IND',
   'SEA TYP',
   'APP IND',
   'INT CON WV',
   'AND LOCTYP 995',
   'Bet LOCTYP 995',
   'LOC1 TYPE',
   'LOC2 TYPE',
   'NOTAPPL',
   'ACT',
   'FT TYPE',
   'PSC',
   'ID REQ IND',
   'LOC TYPE',
   'TOD IND',
   'RET IND',
   'NEG IND',
   'WAV CODE',
   'E/L CODE',
   'WAV E/L',
   'WAV U',
   'APP CODE',
   'FROM LOCTYP 995',
   'TO LOCTYP 995',
   'IMM TKT IND',
   'NOT PERM IND',
   'WAIT CODE',
   'SEG CODE',
   'EACH SEG IND',
   'DEPART OP CODE',
   'DEPART U',
   'BOTH CODE',
   'EXC UNIT',
   'TOD APP IND',
   'SUR TYPE',
   'TVL POR IND',
   'SEC POR IND',
   'PER APP CODE',
   'FROM LOCTYP',
   'BET LOCTYP',
   'AND LOCTYP',
   'VOL IND',
   'INVOL IND',
   'CAN REF',
   'TKT REF',
   'CAN IND',
   'FAIL IND',
   'REISSUE IND',
   'REPLACE IND',
   'CHANGE IND',
   'PTA IND',
   'POR CODE',
   'H/L IND',
   'DEA WAV IND',
   'ILL WAV IND',
   'F DEA WAV IND',
   'F ILL WAV IND',
   'SCH C IND',
   'TKT UG IND',
   'NOT BOTH IND',
   'OPEN JAW',
   'CIRCLE TRIP',
   'CIRCLE T PL',
   'GATE PERM',
   'MAX TIME U',
   'APP 1 IND',
   'DEC 1 NO',
   'DEC 2 NO',
   'SAME CXR CODE',
   'I/O',
   'CHARGE CODE',
   'TKT VAL IND',
   'JRNY CODE',
   'PRICE UNIT',
   'FARE CO CODE',
   'FROM CODE',
   'TO CODE',
   'H/L CODE',
   'DEC',
   'ASSESS CODE',
   'FEE APP CODE',
   'TKT TYPE',
   'RES TYPE',
   'REF TYPE',
   'ENDO TYPE',
   'TKT LIMIT',
   'ADV RES',
   'FULL FLOWN',
   'ORG SCH REF',
   'CANCEL IND',
   'FARE POINT',
   'RE IND',
   'PVT PUB IND',
   'FIELD IND',
   'SAME CODE',
   'OW/RT',
   'FARE AMT',
   'BOOK CODE',
   'H/L AMT',
   'DEC 3 NO',
   'PU/FC',
   'CALC OP',
   'REFUND',
   'NON REF CODE',
   'RES TKT CODE',
   'IND TAG',
   'RES CODE',
   'TVL IND',
   'TKT TYPE IND',
   'LOCALE LOCTYP',
   'LOC TYPE CODE',
   'CXN STOP',
   'NO HIP',
   'ALL SEC IND',
   'OUT JRNY IND',
   'ONE SEC IND',
   'SAME COM IND',
   'SAME RUL IND',
   'ACC PASS IND',
   'FARE BOOK',
   'DEP REQ CODE',
   'FIRST MIN DEC',
   'SEC MIN DEC',
   'SEAT DEP IND',
   'NON REF IND',
   'FIRST REF DEC',
   'SEC REF DEC',
   'REF APP CODE',
   'WAV APP CODE',
   'DEATH CODE',
   'ILL CODE',
   'SCH CHANGE',
   'TKT UG',
   'DENIAL DOCS',
   'JURY DUTY',
   'MIL ORDER',
   'AIRFARE INC',
   'FULL SEATS',
   'DEP LOCTYP',
   'REF LOCTYP',
   'FIRST CLASS',
   'BUS CLASS',
   'ECO CLASS',
   'COACH CLASS',
   'OFF CO CLASS',
   'SUPER IND',
   'OW RULE IND',
   'RT RULE IND',
   'OW IND',
   'RT IND',
   'CT IND',
   'OJ IND',
   'SOJ IND',
   'ORIGIN SOJ IND',
   'TA SOJ IND',
   'DOJ IND',
   'RTW IND',
   'JT IND',
   'INC TOUR',
   'GROUP CODE',
   'PUR CODE',
   'INTER POINTS',
   'D/I CODE',
   'LOCALE CODE',
   'REL IND 1',
   'REL IND 2',
   'DIR IND',
   'LOC VAL IND',
   'LOC CODE IND',
   'VIA IND',
   'HID IND',
   'NON STOP IND',
   'DIRECT IND',
   'MUL STOP IND',
   'ONE STOP IND',
   'ONLINE IND',
   'INTER IND',
   'SAME IND',
   'EQP CODE IND',
   'VIA LOCTYP',
   'PRM',
   'SME',
   'INTERLINE',
   'OTH CXR',
   'T SME',
   'T INTERLINE',
   'T OTH CXR',
   'OR',
   'SURF TAG',
   'EMB TAG',
   'APPL',
   'DEC NO 1',
   'DEC NO 2',
   'TRAN APPL',
   'PRIMARY',
   'CNX OR STOP',
   'CXR APP CODE',
   'TYPE CODE',
   'BET LOC',
   'GATEWAY',
   'RESTRICTION',
   'POR IND',
   'NO DISC IND',
   'FARE IND',
   'FARE TYPE',
   'BOOK APP IND',
   'DEC 1',
   'DEC 2',
   'TKT CODE MOD',
   'TKT DES MOD',
   'OUT IND',
   'SAME COMP',
   'SAME RULE',
   'ACC PASS',
   'FARE BOOK IND',
   'EOD',
   'MIN NO PASS',
   'MAX NO PASS',
   'S. MIN NO PASS',
   'S. MAX NO PASS',
   'CON IND',
   'PRO IND',
   'DIFF IND',
   'EXT IND',
   'FARE CLASS',
   'VAL IND',
   'APP TYPE',
   'CH FARE TYPE',
   'NM REQ TYPE',
   'NM APP CODE',
   'ITI',
   'PNR',
   'TKT IMM',
   'SUB TKT IMM',
   'OUT/IN',
   'TIME APP',
   'PERM CODE',
   'OUT/IN/CHANGE',
   'DECIMAL 1',
   'DECIMAL 2',
   'TOUR DECIMAL 1',
   'TOUR DECIMAL 2',
   'TVL CODE',
   'DIFF GRP',
   'WRT APP',
   'MIN AMT 1 APP',
   'ADD 1 APP',
   'MIN AMT 2 APP',
   'ADD 2 APP',
   'TOUR APP CODE',
   'NON REF',
   'WAV APP',
   'DEATH IND',
   'ILL IND',
   'SCH CH IND',
   'DOC DEN IND',
   'JURY IND',
   'MIL IND',
   'FARE INC IND',
   'PAY REC IND',
   'GR DECIMAL',
   'GR APP',
   'METHOD TYPE',
   'NET/GROSS',
   'UG IND',
   'BAG NO APP',
   'COUPON CODE',
   'TOUR CODE',
   'TKT FARE DATA',
   'OWRT IND',
   'STC',
   'FARE BOX DEC',
   'R TYPE',
   'RES OWRT',
];
export const FIELDS_WITH_TWO_CHARACTER_LIMIT = [
   'CXR',
   'FT',
   'OC',
   'DC',
   'CAT#',
   'TSI 995',
   'AND TSI 995',
   'Bet TSI 995',
   'MAX AGE',
   'S. MAX AGE',
   'MIN AGE',
   'S. MIN AGE',
   'RET OCCUR',
   'MIN STAY U',
   'FROM TSI 995',
   'TO TSI 995',
   'FIRST U',
   'LAST U',
   'OTH RES IND',
   'TKT U',
   'TSI',
   'FROM TSI',
   'BET TSI',
   'AND TSI',
   'MIN NUM',
   'MAX NUM',
   'OUT NUM',
   'IN NUM',
   'SAME STOP',
   'SAME TRANSITS',
   'SAME CONNECT',
   'FIRST AMT NUM',
   'ADD AMT 1 NUM',
   'STOP NUM',
   'ORG SCH U',
   'CUST U',
   'LOCALE TSI',
   'NON R LOCTYP',
   'NON R TSI',
   'DEP TSI',
   'REF TSI',
   'VIA TSI',
   'MIN',
   'MAX',
   'MAX PRM',
   'MAX SME',
   'MAX INTER',
   'MAX OTH CXR',
   'OUT',
   'IN',
   'CHARGE 1 NO',
   'CHARGE 2 NO',
   'NO OF SEGS',
   'NUM',
   'RES BC',
   'NO OF CHILD',
   'NM UNIT',
   'EL TIME U',
   'ADD TIME U',
   'SUB EL TIME U',
   'SUB EL U',
   'MIN NO SEC',
   'NO TOUR COND',
   'MAX TOUR COND',
   'NO OF NIGHTS',
   'MIN TRANSFER',
   'CAR REN DAY',
   'RESORT DAY',
   'OTH GR DAY',
   'FREE DAYS',
   'BAG NO',
   'GLOBAL IND',
   'MKT CXR',
   'OP CXR',
   'BATCH CODE',
];
export const FIELDS_WITH_THREE_CHARACTER_LIMIT = [
   'ORG',
   'DES',
   'TAR',
   'CUR',
   'MAX ST',
   'FTC',
   'PTC',
   'S. PTC',
   'SEGS',
   'FIRST OCC',
   'LAST OCC',
   'MIN STAY P',
   'WAV P',
   'FIRST P',
   'LAST P',
   'TKT P',
   'TIME DEPART',
   'EXC TIME',
   'EQP CODE',
   'CURR 1 CODE',
   'CURR 2 CODE',
   'MIN TIME P',
   'SEG NUM',
   'IN CXR',
   'CURR CODE',
   'ORG SCH P',
   'RTN',
   'CURR 3',
   'CUST P',
   'NO OF MILES',
   'FIRST MIN CURR',
   'SEC MIN CURR',
   'DEP CODE',
   'FIRST REF CURR',
   'SEC REF CURR',
   'REF DAYS',
   'SEG NO',
   'CXR CODE 1',
   'CXR CODE 2',
   'CXR CODE 3',
   'IN CXR CODE',
   'OUT CXR CODE',
   'FIRST TVL',
   'LAST TVL',
   'CURR 2',
   'CURR 1',
   'TOUR CURR 1',
   'TOUR CURR 2',
   'NO OF SEG',
   'GROUP TYPE',
   'FLIGHT NO',
   'NM PERIOD',
   'ADD PASS NO',
   'EL TIME P',
   'ADD TIME P',
   'SUB PASS NO',
   'SUB EL TIME P',
   'SUB EL P',
   'TOUR TYPE',
   'CXR CODE',
   'PRICE CURR 1',
   'GR CURR',
   'TKT CXR CODE',
   'FARE BOX CURR',
   'FARE CODE',
];
export const FIELDS_WITH_FOUR_CHARACTER_LIMIT = [
   'RTG',
   'RULE',
   'LOC1',
   'LOC2',
   'RET TM',
   'START TOD',
   'TOD',
   'G MIL',
   'L MIL',
   'FIRST TOD',
   'LAST TOD',
   'TKT TOD',
   'DIS TYPE',
   'RULE NUM',
   'DIS TAG',
   'FLIGHT NO 1',
   'FLIGHT NO 2',
   'FLIGHT NO 3',
   'MIN GRP',
   'MAX GRP',
   'DE TOD',
   'SUB TKT TOD',
   'MIN NUM PASS',
   'MIN TOUR PASS',
   'MAX TOUR PASS',
   'NO PAY PASS',
   'RULE NO',
   'FLT NO 1',
   'FLT NO 2',
];
export const FIELDS_WITH_FIVE_CHARACTER_LIMIT = [
   'LOC1 995',
   'LOC2 995',
   'AND LOC1 995',
   'AND LOC2 995',
   'Bet LOC1 995',
   'Bet LOC2 995',
   'LOC CODE',
   'STOP TOD',
   'FROM LOC1 995',
   'FROM LOC2 995',
   'TO LOC1 995',
   'TO LOC2 995',
   'FROM LOC1',
   'FROM LOC2',
   'BET LOC1',
   'BET LOC2',
   'AND LOC1',
   'AND LOC2',
   'LOCALE LOC1',
   'LOCALE LOC2',
   'NON R LOC1',
   'NON R LOC2',
   'DEP LOC1',
   'DEP LOC2',
   'REF LOC1',
   'REF LOC2',
   'VIA LOC1',
   'VIA LOC2',
   'LOC 1 CODE',
   'LOC 2 CODE',
   'BET CITY CODE',
   'AND CITY CODE',
   'BATCH NUM',
];
export const FIELDS_WITH_SIX_CHARACTER_LIMIT = [
   'DG',
   'CR USER',
   'FARE',
   'DOW IND',
   'MIN STAY D',
   'MAX STAY D',
   'WAV DATE',
   'START P',
   'STOP P',
   'LAST DATE',
];
export const FIELDS_WITH_SEVEN_CHARACTER_LIMIT = [
   'CHG DT',
   'SEA ST',
   'SEA END',
   'BLACKOUT ST',
   'BLACKOUT END',
   'TLV ST',
   'TLV END',
   'TLV CMPLT',
   'TVLEFF 994',
   'TVLDIS 994',
   'RESEFF 994',
   'RESDISC 994',
   'FST TKT',
   'LST TKT',
   'FST RES',
   'LST RES',
   'SEQUENCE',
   'FIRST AMT',
   'ADD AMT 1',
   'FIRST AMT 2',
   'ADD AMT 2',
   'PEN PERCENT',
   'MIN AMT',
   'BASE PERCENT',
   'FIRST MIN AMT',
   'SEC MIN AMT',
   'FARE PER DEP',
   'FIRST REF AMT',
   'SEC REF AMT',
   'REF PERCENT',
   'CHARGE 1 AMT',
   'CHARGE 2 AMT',
   'CHARGE 3 AMT',
   'CHARGE 4 AMT',
   'SPEC FARE 1',
   'SPEC FARE 2',
   'CH PERCENT',
   'GR PERCENT',
   'MAX PERCENT',
   'MIN AMT 1',
   'ADD 1 AMT',
   'MIN AMT 2',
   'ADD 2 AMT',
   'MIN PERCENT',
   'MIN TOUR AMT 1',
   'MIN TOUR AMT 2',
   'MIN GR AMT',
   'COMM PERCENT',
   'COMM 1 AMT',
   'COMM 2 AMT',
   'FARE BOX AMT',
];
export const FIELDS_WITH_EIGHT_CHARACTER_LIMIT = [
   'FBC',
   'JUSTIFICATION',
   'REC3ID',
   'OVRD 994',
   'GEO 995',
   'TEXT 996',
   'AND GEO 995',
   'Bet GEO 995',
   'JT CXR TBL',
   'GEO 995',
   'FROM GEO 995',
   'TO GEO 995',
   'FLIGHT 986 ID',
   'BET GEO 995',
   'AND GEO 995',
   'POINT 993',
   'REISSUE 988',
   'WAIVER 987',
   'FCC',
   'S. FCC',
   'CXR 990',
   'FARE TYPE 974',
   'WAV 987',
   'LOCALE GEO',
   'NON R GEO',
   'DEP GEO 995',
   'REF GEO 995',
   'ADD FARE TEXT ID',
   'CAPA TEXT ID',
   'NO APP ID',
   'OTHER TEXT ID',
   'CXR 1 986 ID',
   'CXR 2 986 ID',
   'VIA GEO 995',
   'SURF 976 ID',
   'EMB 976 ID',
   'IN CXR 990 ID',
   'OUT CXR CODE',
   'OUT CXR 990 ID',
   'LOC 978 ID',
   'FARE APP',
   'RES FCC',
   'TOUR NO',
   'SEC 983 ID',
   'FARE 979 ID',
   'AND995ID',
   'BET995ID',
   'GEO995ID',
   'GR AND995ID',
   'GR BET995ID',
   'GR TO AND995ID',
   'GR TO BET995ID',
   'IND AND995ID',
   'IND BET995ID',
];
export const FIELDS_WITH_TEN_CHARACTER_LIMIT = [
   'TKT CODE',
   'TKT DES',
   'TKT DESG',
];
export const FIELDS_WITH_FIFTEEN_CHARACTER_LIMIT = ['TOUR BOX'];
export const FIELDS_WITH_TWENTY_CHARACTER_LIMIT = ['AC'];
export const FIELD_WITH_ELEVEN_CHARACTER_LIMIT = [
   'REFUND IND',
   'TRANSFER',
   'FARE BOX TXT',
   'STATUS',
];
export const EMAIL_FIELDS = ['EMAIL'];
export const APP_TITLE = ['APP TITLE'];
export const AMOUNT_FIELDS = [
   'AMT',
   'SUR',
   'YQ',
   'YR',
   'TAX',
   'TTL',
   'AP',
   'SUR 1 AMT',
   'SUR 2 AMT',
   'PERCENT',
   'PEN 1 AMT',
   'PEN 2 AMT',
   'BASE PERCENT',
   'FARE PER DEP',
   'REF PERCENT',
   'CH PERCENT',
   'GR PERCENT',
   'MAX PERCENT',
   'OW AMT',
   'RT AMT',
];
export const NUMERIC_FIELDS = [
   'TAR',
   'FARE',
   'DG',
   'CAT#',
   'REC3ID',
   'OVRD 994',
   'GEO 995',
   'TEXT 996',
   'AND GEO 995',
   'Bet GEO 995',
   'RTG',
   'SEQUENCE',
   'JT CXR TBL',
   'SEGS',
   'DIST GRP',
   'MAX AGE',
   'S. MAX AGE',
   'MIN AGE',
   'S. MIN AGE',
   'FIRST OCC',
   'LAST OCC',
   'GEO 995',
   'G MIL',
   'L MIL',
   'FROM GEO 995',
   'TO GEO 995',
   'FLIGHT 986 ID',
   'BET GEO 995',
   'AND GEO 995',
   'MIN TIME P',
   'SAME STOP',
   'SAME TRANSITS',
   'SAME CONNECT',
   'FIRST AMT',
   'ADD AMT 1',
   'DEC 1 NO',
   'FIRST AMT 2',
   'ADD AMT 2',
   'DEC 2 NO',
   'SEG NUM',
   'POINT 993',
   'PEN PERCENT',
   'MIN AMT',
   'DEC',
   'REISSUE 988',
   'WAIVER 987',
   'RTN',
   'DEC 3 NO',
   'CXR 990',
   'FARE TYPE 974',
   'WAV 987',
   'NO OF MILES',
   'LOCALE GEO',
   'NON R GEO',
   'FIRST MIN AMT',
   'FIRST MIN DEC',
   'SEC MIN AMT',
   'SEC MIN DEC',
   'DEP CODE',
   'FIRST REF AMT',
   'FIRST REF DEC',
   'SEC REF AMT',
   'SEC REF DEC',
   'REF DAYS',
   'DEP GEO 995',
   'REF GEO 995',
   'SEG NO',
   'ADD FARE TEXT ID',
   'CAPA TEXT ID',
   'NO APP ID',
   'OTHER TEXT ID',
   'CXR 1 986 ID',
   'CXR 2 986 ID',
   'VIA GEO 995',
   'MIN',
   'SURF 976 ID',
   'EMB 976 ID',
   'CHARGE 1 AMT',
   'CHARGE 2 AMT',
   'CHARGE 3 AMT',
   'CHARGE 4 AMT',
   'NO OF SEGS',
   'OUT CXR 990 ID',
   'FIRST TVL',
   'LAST TVL',
   'SPEC FARE 1',
   'DEC 1',
   'SPEC FARE 2',
   'DEC 2',
   'TKT CODE MOD',
   'TKT DES MOD',
   'NO OF SEG',
   'MIN NO PASS',
   'S. MIN NO PASS',
   'MAX NO PASS',
   'S. MAX NO PASS',
   'MIN GRP',
   'MAX GRP',
   'FLIGHT NO',
   'NO OF CHILD',
   'MIN NO SEC',
   'DECIMAL 1',
   'DECIMAL 2',
   'TOUR DECIMAL 1',
   'TOUR DECIMAL 2',
   'MIN NUM PASS',
   'MIN TOUR PASS',
   'MAX TOUR PASS',
   'NO TOUR COND',
   'NO PAY PASS',
   'MAX TOUR COND',
   'NO OF NIGHTS',
   'MIN AMT 1',
   'ADD 1 AMT',
   'MIN AMT 2',
   'ADD 2 AMT',
   'MIN PERCENT',
   'MIN TOUR AMT 1',
   'MIN TOUR AMT 2',
   'MIN GR AMT',
   'GR DECIMAL',
   'MIN TRANSFER',
   'CAR REN DAY',
   'RESORT DAY',
   'OTH GR DAY',
   'FREE DAYS',
   'SEC 983 ID',
   'FARE 979 ID',
   'COMM PERCENT',
   'COMM 1 AMT',
   'COMM 2 AMT',
   'BAG NO',
   'FARE BOX AMT',
   'AND995ID',
   'BET995ID',
   'GEO995ID',
   'GR AND995ID',
   'GR BET995ID',
   'GR TO AND995ID',
   'GR TO BET995ID',
   'IND AND995ID',
   'IND BET995ID',
   'GRT',
   'OWRT',
   'RES OWRT',
   'BATCH NUM',
];
export const ALPHA_NUMERIC_FIELDS_WITH_STAR = [
   'FLIGHT NO 1',
   'FLIGHT NO 2',
   'FLIGHT NO 3',
   'FLT NO 1',
   'FLT NO 2',
];

export const ALPHA_ONLY_FIELDS = [
   'ORG',
   'CUR',
   'DES',
   'CAB',
   'RBD',
   'FTC',
   'DOW TC',
   'SEAS TC',
   'PTC',
   'REL IND',
   'IGN ERR',
   'LFC',
   'TAX IND',
   'EX IND',
   'JUSTIFICATION',
   'OC',
   'DC',
];
export const ALPHA_NUMERIC_FIELDS = [
   'CXR',
   'FT',
   'CAT NM',
   'LOC1 TYPE',
   'LOC1',
   'LOC2 TYPE',
   'LOC2',
   'NOTAPPL',
   'FARES',
   'ACT',
   'BATCH CODE',
   'FT TYPE',
   'S',
   'CHG USER',
   'RULE',
   'TKT DSG',
   'VCC',
   'GFS',
   'IO',
   'DIR',
   'TVL ST',
   'TVL END',
   'TVL CMPLT',
   'RI',
   'TVLEFF 994',
   'TVLDIS 994',
   'RESEFF 994',
   'RESDISC 994',
   'LOCTYP 995',
   'LOC1 995',
   'LOC2 995',
   'TSI 995',
   'RET TM',
   'UVD',
   'TEXT 996',
   'OVR IND',
   'SEA TYP',
   'SEA ST',
   'SEA END',
   'APP IND',
   'INT CON WV',
   'BLACKOUT ST',
   'BLACKOUT END',
   'AND LOCTYP 995',
   'AND LOC1 995',
   'AND LOC2 995',
   'AND TSI 995',
   'Bet LOCTYP 995',
   'Bet LOC1 995',
   'Bet LOC2 995',
   'Bet TSI 995',
   'FST TKT',
   'LST TKT',
   'FST RES',
   'LST RES',
   'EFF DT',
   'CHG DT',
   'DISC DT',
   'START TOD',
   'STOP TOD',
   'TOD IND',
   'RET OCCUR',
   'RET IND',
   'NEG IND',
   'MIN STAY P',
   'MIN STAY U',
   'DOW IND',
   'TOD',
   'WAV CODE',
   'E/L CODE',
   'MIN STAY D',
   'MAX STAY D',
   'WAV DATE',
   'WAV E/L',
   'WAV P',
   'WAV U',
   'APP CODE',
   'FROM LOCTYP 995',
   'FROM LOC1 995',
   'FROM LOC2 995',
   'FROM TSI 995',
   'TO LOCTYP 995',
   'TO LOC1 995',
   'TO LOC2 995',
   'TO TSI 995',
   'FIRST TOD',
   'FIRST P',
   'FIRST U',
   'LAST TOD',
   'LAST P',
   'LAST U',
   'OTH RES IND',
   'IMM TKT IND',
   'NOT PERM IND',
   'WAIT CODE',
   'SEG CODE',
   'EACH SEG IND',
   'TKT TOD',
   'TKT P',
   'TKT U',
   'DEPART OP CODE',
   'TIME DEPART',
   'DEPART U',
   'TSI',
   'BOTH CODE',
   'EXC TIME',
   'EXC UNIT',
   'START P',
   'STOP P',
   'TOD APP IND',
   'SUR TYPE',
   'EQP CODE',
   'TVL POR IND',
   'SEC POR IND',
   'CURR 1 CODE',
   'CURR 2 CODE',
   'PER APP CODE',
   'FLIGHT 986',
   'FROM LOCTYP',
   'FROM LOC1',
   'FROM LOC2',
   'FROM TSI',
   'BET LOCTYP',
   'BET LOC1',
   'BET LOC2',
   'BET TSI',
   'AND LOCTYP',
   'AND LOC1',
   'AND LOC2',
   'AND TSI',
   'VOL IND',
   'INVOL IND',
   'CAN REF',
   'TKT REF',
   'CAN IND',
   'FAIL IND',
   'REISSUE IND',
   'REPLACE IND',
   'CHANGE IND',
   'PTA IND',
   'REFUND IND',
   'POR CODE',
   'H/L IND',
   'DEA WAV IND',
   'ILL WAV IND',
   'F DEA WAV IND',
   'F ILL WAV IND',
   'SCH C IND',
   'TKT UG IND',
   'MIN NUM',
   'MAX NUM',
   'OUT NUM',
   'IN NUM',
   'NOT BOTH IND',
   'OPEN JAW',
   'CIRCLE TRIP',
   'CIRCLE T PL',
   'GATE PERM',
   'MAX TIME U',
   'APP 1 IND',
   'FIRST AMT NUM',
   'ADD AMT 1 NUM',
   'SAME CXR CODE',
   'STOP NUM',
   'IN CXR',
   'I/O',
   'CHARGE CODE',
   'TKT VAL IND',
   'JRNY CODE',
   'PRICE UNIT',
   'FARE CO CODE',
   'FROM CODE',
   'TO CODE',
   'H/L CODE',
   'CURR CODE',
   'ASSESS CODE',
   'FEE APP CODE',
   'TKT TYPE',
   'DIS TYPE',
   'RES TYPE',
   'REF TYPE',
   'ENDO TYPE',
   'TKT LIMIT',
   'ADV RES',
   'FULL FLOWN',
   'ORG SCH REF',
   'ORG SCH P',
   'ORG SCH U',
   'CANCEL IND',
   'FARE POINT',
   'RE IND',
   'PVT PUB IND',
   'RULE NUM',
   'FIELD IND',
   'FCC',
   'S. FCC',
   'S. PTC',
   'SAME CODE',
   'FARE CODE',
   'OW/RT',
   'FARE AMT',
   'BOOK CODE',
   'H/L AMT',
   'CURR 3',
   'PU/FC',
   'CALC OP',
   'DIS TAG',
   'REFUND',
   'NON REF CODE',
   'CUST P',
   'CUST U',
   'RES TKT CODE',
   'IND TAG',
   'RES CODE',
   'TVL IND',
   'TKT TYPE IND',
   'LOCALE LOCTYP',
   'LOCALE LOC1',
   'LOCALE LOC2',
   'LOCALE TSI',
   'NON R LOCTYP',
   'NON R LOC1',
   'NON R LOC2',
   'NON R TSI',
   'LOC TYPE CODE',
   'CXN STOP',
   'NO HIP',
   'ALL SEC IND',
   'OUT JRNY IND',
   'ONE SEC IND',
   'SAME COM IND',
   'SAME RUL IND',
   'ACC PASS IND',
   'FARE BOOK',
   'DEP REQ CODE',
   'FIRST MIN CURR',
   'SEC MIN CURR',
   'LAST DATE',
   'SEAT DEP IND',
   'NON REF IND',
   'FIRST REF CURR',
   'SEC REF CURR',
   'REF APP CODE',
   'WAV APP CODE',
   'DEATH CODE',
   'ILL CODE',
   'SCH CHANGE',
   'TKT UG',
   'DENIAL DOCS',
   'JURY DUTY',
   'MIL ORDER',
   'AIRFARE INC',
   'FULL SEATS',
   'DEP LOCTYP',
   'DEP LOC1',
   'DEP LOC2',
   'DEP TSI',
   'REF LOCTYP',
   'REF LOC1',
   'REF LOC2',
   'REF TSI',
   'APP TITLE',
   'FIRST CLASS',
   'BUS CLASS',
   'ECO CLASS',
   'COACH CLASS',
   'OFF CO CLASS',
   'SUPER IND',
   'OW RULE IND',
   'RT RULE IND',
   'OW IND',
   'RT IND',
   'CT IND',
   'OJ IND',
   'SOJ IND',
   'ORIGIN SOJ IND',
   'TA SOJ IND',
   'DOJ IND',
   'RTW IND',
   'JT IND',
   'INC TOUR',
   'GROUP CODE',
   'PUR CODE',
   'INTER POINTS',
   'D/I CODE',
   'LOCALE CODE',
   'ADD FARE TEXT',
   'CAPA TEXT',
   'NO APP TEXT',
   'OTHER TEXT',
   'CXR CODE 1',
   'CXR 1 986',
   'REL IND 1',
   'CXR CODE 2',
   'CXR 2 986',
   'REL IND 2',
   'CXR CODE 3',
   'DIR IND',
   'LOC VAL IND',
   'LOC CODE IND',
   'VIA IND',
   'HID IND',
   'NON STOP IND',
   'DIRECT IND',
   'MUL STOP IND',
   'ONE STOP IND',
   'ONLINE IND',
   'INTER IND',
   'SAME IND',
   'EQP CODE IND',
   'VIA LOCTYP',
   'VIA LOC1',
   'VIA LOC2',
   'VIA TSI',
   'PRM',
   'MAX PRM',
   'SME',
   'T SME',
   'MAX SME',
   'INTERLINE',
   'T INTERLINE',
   'MAX INTER',
   'OTH CXR',
   'T OTH CXR',
   'MAX OTH CXR',
   'OUT',
   'IN',
   'OR',
   'SURF TAG',
   'EMB TAG',
   'APPL',
   'CHARGE 1 NO',
   'CHARGE 2 NO',
   'DEC NO 1',
   'DEC NO 2',
   'TRAN APPL',
   'NUM',
   'PRIMARY',
   'CNX OR STOP',
   'CXR APP CODE',
   'IN CXR CODE',
   'IN CXR 990 ID',
   'TYPE CODE',
   'LOC 1 CODE',
   'LOC 2 CODE',
   'LOC 978 ID',
   'BET LOC',
   'GATEWAY',
   'RESTRICTION',
   'POR IND',
   'TRANSFER',
   'NO DISC IND',
   'FARE IND',
   'FARE TYPE',
   'FARE APP',
   'BOOK APP IND',
   'BET CITY CODE',
   'AND CITY CODE',
   'CURR 2',
   'CURR 1',
   'TOUR CURR 1',
   'TOUR CURR 2',
   'RES FCC',
   'RES BC',
   'TKT DES',
   'OUT IND',
   'SAME COMP',
   'SAME RULE',
   'ACC PASS',
   'FARE BOOK IND',
   'EOD',
   'CON IND',
   'PRO IND',
   'DIFF IND',
   'EXT IND',
   'GROUP TYPE',
   'FARE CLASS',
   'VAL IND',
   'APP TYPE',
   'CH FARE TYPE',
   'NM REQ TYPE',
   'NM PERIOD',
   'NM UNIT',
   'NM APP CODE',
   'ITI',
   'PNR',
   'ADD PASS NO',
   'DE TOD',
   'EL TIME P',
   'EL TIME U',
   'ADD TIME P',
   'ADD TIME U',
   'TKT IMM',
   'SUB PASS NO',
   'SUB EL TIME P',
   'SUB EL TIME U',
   'SUB TKT TOD',
   'SUB EL P',
   'SUB EL U',
   'SUB TKT IMM',
   'OUT/IN',
   'TIME APP',
   'PERM CODE',
   'OUT/IN/CHANGE',
   'TVL CODE',
   'DIFF GRP',
   'WRT APP',
   'TOUR TYPE',
   'TOUR NO',
   'CXR CODE',
   'MIN AMT 1 APP',
   'ADD 1 APP',
   'MIN AMT 2 APP',
   'ADD 2 APP',
   'PRICE CURR 1',
   'TOUR APP CODE',
   'NON REF',
   'WAV APP',
   'DEATH IND',
   'ILL IND',
   'SCH CH IND',
   'DOC DEN IND',
   'JURY IND',
   'MIL IND',
   'FARE INC IND',
   'PAY REC IND',
   'GR CURR',
   'GR APP',
   'METHOD TYPE',
   'NET/GROSS',
   'UG IND',
   'BAG NO APP',
   'TKT CXR CODE',
   'COUPON CODE',
   'TOUR CODE',
   'TOUR BOX',
   'TKT DESG',
   'TKT FARE DATA',
   'OWRT IND',
   'GLOBAL IND',
   'RULE NO',
   'STC',
   'FARE BOX TXT',
   'FARE BOX CURR',
   'FARE BOX DEC',
   'DOWT',
   'TYP',
   'ST',
   'GENRULE',
   'GRN',
   'R TYPE',
   'MKT CXR',
   'OP CXR',
   'MAX',
];

export const ALPHA_NUMERIC_FIELD_WITH_HYPHEN = ['TKT CODE'];

export const DATE_STRING_FIELDS = [
   'REC DT',
   'EFF DT',
   'DISC DT',
   'RES DATE',
   'TKT DATE',
];
export const NON_ACCORDION_CATEGORY = ['Data', 'Record 2', 'Record 2 Segments'];
export const ALLOW_PIPE_SYMBOL_FIELD = [
   'RULE TVL DT',
   'SEAS DT',
   'BO DT',
   'FT BO DT',
   'APPL DT',
   'FT SEAS DT',
   'FT BO DT',
];
export const ROW_COPY_ENABLED_FARES_SCREEN_COLUMN = [
   'org',
   'des',
   'cxr',
   'fbc',
   'tar',
   'owrt',
   'cur',
   'amt',
   'ttl',
   'rtg',
   'ft',
   'eff dt',
   'disc dt',
   'uac',
   'ow amt',
   'rt amt',
];

export const SPECIAL_CHAR_FIELDS = ['REL'];
export const ALPHA_NUMERIC_FIELDS_WITH_ATPCO_WILD_CARDS = ['FBC'];
export const API_STATUS = {
   IN_PROGRESS: 'IN_PROGRESS',
   SUCCESS: 'SUCCESS',
   FAILED: 'FAILED',
   ABORTED: 'ABORTED',
   NO_RESULTS: 'NO_RESULTS',
   COMPLETED: 'COMPLETED',
};
export const RECORD_3_CATEGORIES_WITH_NESTED_FIELDS = [
   8, 9, 13, 15, 19, 20, 21, 22, 27, 35, 50,
];
export const NESTED_RECORD_3_ARRAYS = [
   {
      category: 8,
      fieldName: 'stopOverLocations',
   },
   {
      category: 9,
      fieldName: 'transferSegments',
   },
   {
      category: 13,
      fieldName: 'accompanyingTravelCodeList',
   },
   {
      category: 15,
      fieldName: 'salesSegmentList',
   },
   {
      category: 19,
      fieldName: 'accompanyingPassengers',
   },
   {
      category: 20,
      fieldName: 'accompanyingPassengers',
   },
   {
      category: 21,
      fieldName: 'accompanyingPassengers',
   },
   {
      category: 22,
      fieldName: 'accompanyingPassengers',
   },
   {
      category: 27,
      fieldName: 'groundCruiseRequirements',
   },
   {
      category: 35,
      fieldName: 'ticketingSegments',
   },
   {
      category: 50,
      fieldName: 'ruleApplicationLocales',
   },
];
export const ROW_EDIT_ENABLED_DEFAULT_FARES_COLUMN = [
   'ft',
   'amt',
   'fbc',
   'eff dt',
   'disc dt',
   'ow amt',
   'rt amt',
];
export const ROW_EDIT_ENABLED_DISTRIBUTION_SCREEN_COLUMN = [
   'last update',
   'dist dt',
   'description',
   'int dist dt',
   'ex ind',
   'rel ind',
   'ign err',
   'lfc',
   'tax ind',
   'justification',
   'email',
];
export const CAMEL_CASE_ACTION = {
   BLUR: 'Blur',
   UPDATES: 'Updates',
   CANCEL: 'Cancel',
   CHANGE: 'Change',
   UNDO: 'Undo',
   SEARCH_ACTION: 'SearchAction',
   PAGINATION_ACTION: 'PaginationAction',
   SEARCH: 'Search',
};
export const CAMEL_CASE_TYPES = {
   TEMPLATE: 'Template',
   MULTIEDIT: 'MultiEdit',
   SUCCESS: 'Success',
   REJECT: 'Reject',
   PRIMARY_TABLE: 'PrimaryTable',
   SECONDARY_TABLE: 'SecondaryTable',
   SAVE: 'Save',
   COPY: 'Copy',
   DELETE: 'Delete',
   DISTRIBUTE_APPROVE: 'Distribute/Approve',
   ALL: 'All',
   CELL: 'Cell',
   MULTIPLE: 'Multiple',
   OVER_WRITE: 'Overwrite',
   COPYING: 'Copying',
   SAVE_ALL: 'Save All',
   DISCARD: 'Discard',
   SINGLE: 'Single',
};
export const SCREEN_NAMES = {
   FARES: 'Fares',
   REFERENCE: 'Reference',
   MARKET_LIST: 'Market List',
   DISTRIBUTION_GROUP: 'Distribution Groups',
   FOOTNOTES: 'Footnotes',
   RULES: 'Rules',
};
export const USER_ACTION_CODE_FARES_SCREEN = {
   UPDATE: 'U',
   NEW: 'N',
   ERROR: 'E',
   CLOSE: 'X',
};
export const FARE_STATUS = {
   WORKING: 'W',
   DISTRIBUTED: 'D',
};
export const SYSTEM_KEY = {
   ARROW_UP: 'ArrowUp',
   ARROW_DOWN: 'ArrowDown',
   BACK_SPACE: 'Backspace',
};
export const DISTRIBUTION_FINAL_STATUS = 'DISTRIBUTED';

export const FORM_DATA_ACTION_TYPE = {
   RESET_FORM: 'RESET_FORM',
   UPDATE_SECTION: 'UPDATE_SECTION',
   ADD_FIELD: 'ADD_FIELD',
   UPDATE_FIELD: 'UPDATE_FIELD',
};

export const API_RESPONSE_KEY_NAMES = {
   FARES: 'resolvedFares',
   FOOTNOTES: 'record2s',
};
export const DISTRIBUTION_STATUS = {
   DISTRIBUTED: 'DISTRIBUTED',
};

export const APPROVAL_NEEDED_EDIT_FIELD = ['intDistributionTimeStamp'];

export const DISTRIBUTION_ACTIONS = {
   UPDATED: 'DG UPDATED',
   NOTE: 'NOTE',
};

export const LAST_UPDATED_SUFFIX = ' - fields are last updated';

export const CARRIER_CODE = 'carrierCode';

export const LAST_SAVED_TABLE_TYPE = {
   MAIN_TABLE: 'MAIN',
   LOG_TABLE: 'LOG',
};

export const WEEK_DAYS = [
   { label: '--Select--', value: '--Select--' },
   { label: 'Everyday', value: 'Everyday' },
   { label: 'Monday', value: 'Monday' },
   { label: 'Tuesday', value: 'Tuesday' },
   { label: 'Wednesday', value: 'Wednesday' },
   { label: 'Thursday', value: 'Thursday' },
   { label: 'Friday', value: 'Friday' },
   { label: 'Saturday', value: 'Saturday' },
   { label: 'Sunday', value: 'Sunday' },
];
export const DAILY_HOURS = [
   { label: '0000', value: '0000' },
   { label: '0100', value: '0100' },
   { label: '0200', value: '0200' },
   { label: '0300', value: '0300' },
   { label: '0400', value: '0400' },
   { label: '0500', value: '0500' },
   { label: '0600', value: '0600' },
   { label: '0700', value: '0700' },
   { label: '0800', value: '0800' },
   { label: '0900', value: '0900' },
   { label: '1000', value: '1000' },
   { label: '1100', value: '1100' },
   { label: '1200', value: '1200' },
   { label: '1300', value: '1300' },
   { label: '1400', value: '1400' },
   { label: '1500', value: '1500' },
   { label: '1600', value: '1600' },
   { label: '1700', value: '1700' },
   { label: '1800', value: '1800' },
   { label: '1900', value: '1900' },
   { label: '2000', value: '2000' },
   { label: '2100', value: '2100' },
   { label: '2200', value: '2200' },
   { label: '2300', value: '2300' },
];
export const SATURDAY_HOURS = [
   { label: '0000', value: '0000' },
   { label: '0100', value: '0100' },
   { label: '0200', value: '0200' },
   { label: '0300', value: '0300' },
   { label: '0400', value: '0400' },
   { label: '0500', value: '0500' },
   { label: '0600', value: '0600' },
   { label: '0700', value: '0700' },
   { label: '0800', value: '0800' },
   { label: '0900', value: '0900' },
   { label: '1000', value: '1000' },
   { label: '1100', value: '1100' },
   { label: '1200', value: '1200' },
   { label: '1300', value: '1300' },
   { label: '1400', value: '1400' },
   { label: '1500', value: '1500' },
   { label: '1600', value: '1600' },
   { label: '1700', value: '1700' },
];
export const SUNDAY_HOURS = [
   { label: '0600', value: '0600' },
   { label: '0700', value: '0700' },
   { label: '0800', value: '0800' },
   { label: '0900', value: '0900' },
   { label: '1000', value: '1000' },
   { label: '1100', value: '1100' },
   { label: '1200', value: '1200' },
   { label: '1300', value: '1300' },
   { label: '1400', value: '1400' },
   { label: '1500', value: '1500' },
   { label: '1600', value: '1600' },
   { label: '1700', value: '1700' },
   { label: '1800', value: '1800' },
   { label: '1900', value: '1900' },
   { label: '2000', value: '2000' },
   { label: '2100', value: '2100' },
   { label: '2200', value: '2200' },
   { label: '2300', value: '2300' },
];
export const PIPE_SYMBOL = ' | ';
export const STORED_CRITERIA_CONFIG = {
   SAVE_ALL_POPUP_TITLE: 'Save All Confirmation',
   SAVE_ALL_POPUP_BODY: 'Do you want to Save All these changes?.',
   DELETE_POPUP_TITLE: 'Delete Confirmation',
   DELETE_POPUP_BODY: 'Do you want to Delete these changes?.',
   STORED_CRITERIA_TITLE: 'Stored Criteria',
   SELECTED_USER_LABEL: 'Selected User',
};

export const PRODUCT_TYPE = {
   SPECIFIED: 'specified',
   CONSTRUCTED: 'constructed',
};
export const WINNING_FARE = 'winningFare';

export const SEARCH_CRITERIA_CHECKBOX_CATEGORY = {
   PRODUCT_TYPE: 'productType',
   TABLE: 'table',
};

export const PRODUCT_TYPE_C_AND_I = [
   { field: 'specified', key: 'Spec', operator: '=', value: true },
   { field: 'constructed', key: 'Cons', operator: '=', value: true },
];
export const PRODUCT_TYPE_C = [
   { field: 'constructed', key: 'Cons', operator: '=', value: true },
];
export const PRODUCT_TYPE_I = [
   { field: 'specified', key: 'Spec', operator: '=', value: true },
];
export const WINNING_FARES = [
   { field: 'winningFare', key: 'WIN', operator: '=', value: true },
];
export const MAX_LENGTH_FIELDS = {
   ORIGIN: 3,
   DESTINATION: 3,
   CARRIER_CODE: 2,
   FARE_CLASS_CODE: 8,
   MARKET_ID: 20,
   AMOUNT: 11,
   TARIFF_NUMBER: 3,
   FOOTNOTE_CODE: 2,
   ROUTING_NUMBER: 4,
   ROUND_TRIP_INDICATOR: 1,
   CURRENCY_CODE: 3,
   EFFECTIVE_DATE: 7,
   DISCONTINUE_DATE: 7,
};

export const NO_MAX_LIMIT_FIELDS = [
   'AMT',
   'SUR',
   'YQ',
   'YR',
   'TAX',
   'TTL',
   'TKT DSG',
   'DOW',
   'SEAS DT',
   'AP',
   'RULE TVL DT',
   'APPL DT',
   'MIN ST',
   'BO DT',
   'TVL ST',
   'TVL END',
   'TVL CMPLT',
   'FT TVL DT',
   'FT SEAS DT',
   'FT BO DT',
   'GFS',
   'GFS DT',
   'TKT DSG',
   'MKT LST',
   'REC DT',
];

export const ERROR_MESSAGE_LIMIT = 5;
